import React, { useEffect, useRef, useState } from "react";
import { useSubmitGuard } from "../../hooks/useSubmitGuard";
import LeftIcon from "../../images/LeftIcon";
import PrintIcon from "../../images/PrintIcon";
import ArrowRightIcon from "../../images/ArrowRightIcon";
import DraftIcon from "../../images/DraftIcon";
import SaveIcon from "../../images/SaveIcon";
import DatePicker from "react-datepicker";
import PlusGreenIcon from "../../images/PlusGreenIcon";
import DeleteIcon from "../../images/DeleteIcon";
import MinusQuantity from "../../images/MinusQuantity";
import PlusQuantity from "../../images/PlusQuantity";
import PlusActiveIcon from "../../images/PlusActiveIcon";
import CloseIcon from "../../images/CloseIcon";
import PlusIconGray from "../../images/PlusIconGray";
import {
  webLoadingFalse,
  webLoadingTrue,
  webNavigate,
  webRoute,
} from "../../services/navigate.service";
import ErrorIcon from "../../images/ErrorIcon";
import {
  createSales,
  createSalesPayment,
  getDetailSales,
  getInvoiceNumber,
  getListProduct,
  getPaymentType,
  updateSales,
  updateStatus,
} from "../../services/sales.service";
import {
  validateDecimalNumer,
  validateEmail,
  validateNoSpecialChars,
  validateNoSpecialCharsOrSpaces,
  validateOnlyNumbers,
  validateOnlyNumbersNotThree,
  validatePhoneNumber,
} from "../../validation/ValidationInput";
import { getClients } from "../../services/client.service";
import { loadTerm } from "../../services/term.service";
import TagStatus from "../../components/TagStatus";
import UpdateSaleIcon from "../../images/UpdateSaleIcon";
import RejectIcon from "../../images/RejectIcon";
import { getTax } from "../../services/tax.services";
import { getTransactionMonth } from "../../services/purchases.services";
import PopupLocation from "../../components/PopupLocation";
import { useInfiniteScroll } from "../../hook/useInfiniteScroll";
import { DropdownSearch } from "../../components/DropdownSearch";
import { showToast } from "../../services/toast.service";
import { showApiError as showApiErrorToast } from "../../services/apiError";
import BackIcon from "../../images/BackIcon";
import BalanceIcon from "../../images/BalanceIcon";
import { useResponsive } from "../../hook/useResponsive";
import { useAsyncDropdown } from "../../hook/useAsyncDropdown";
import { SalesPrintView } from "./SalesPrintView";
import html2pdf from "html2pdf.js";

interface saleDetailsPayload {
  salesId: string;
  sequenceNo: number;
  recordType: number;
  articleId?: string;
  itemName: string;
  quantity: number;
  sku: string;
  price: number;
  discount?: number;
  net?: number;
  tax?: number;
  amount?: number;
  cost?: number;
  taxId?: string;
  productPriceId: string;
  note?: string;
  isActive?: boolean;
  isDeleted?: boolean;
  createdBy: string;
  updatedAt?: Date;
}
interface Country {
  id: string;
  code: string;
  name: string;
}
interface Status {
  id: string;
  code: string;
  name: string;
}
const CreateSales = () => {
  const preLanguage = localStorage.getItem("language");
  const [language, setLanguage] = useState<any>(null);
  const [showSave, setShowSave] = useState<boolean>(true);
  const { isMobile, getWidth } = useResponsive();
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [formValues, setFormValues] = useState<any>({
    clientId: "",
    companyNumber: "",
    businessAddress: "",
    emailAddress: "",
    transactionMonthsId: "",
    invoiceNumber: "",
    issuedOn: "",
    paymentTerm: "",
  });
  const [showPayment, setShowPayment] = useState<boolean>(false);
  const [openDropdownIndexes, setOpenDropdownIndexes] = useState<{
    [key: number]: boolean;
  }>({});
  const [searchTaxMap, setSearchTaxMap] = useState<any>({});
  const [listPayment, setListPayment] = useState<any>([]);
  const [statusPayment, setStatusPayment] = useState<boolean>(false);
  const [clients, setClients] = useState<any>([]);
  const [payment, setPayemnt] = useState<any>([]);
  const [listTax, setListTax] = useState<any>([]);
  const [listProduct, setListProduct] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchClient, setSearchClient] = useState("");
  const [searchProductPrice, setSearchProductPrice] = useState<any>([]);
  const [paymentType, setPayemntType] = useState("");
  const [formValuesPayment, setFormValuesPayment] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rows, setRows] = useState<any[]>([]);
  // Index of a line just added, so its first field can grab focus and the
  // accountant can keep typing without reaching for the mouse.
  const [autoFocusIndex, setAutoFocusIndex] = useState<number | null>(null);
  const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
  const [isProductPriceDropdownOpen, setIsProductPriceDropdownOpen] = useState<{
    [key: number]: boolean;
  }>({});
  const [isPaymentDropdownOpen, setIsPaymentDropdownOpen] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [isTypeDropdownOpen, setIsTypeDropdownOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [isMonthDropdownOpen, setIsMonthDropdownOpen] = useState(false);
  const [listMonths, setListMonths] = useState<any>([]);
  // Holds the full client record selected from the dropdown so the compact
  // customer-context row can read account-summary fields when the API provides
  // them. Stays null until a client is picked.
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dropdownPaymentRef = useRef<HTMLDivElement>(null);
  const dropdownProductPriceRef = useRef<HTMLDivElement>(null);
  const dropdownTaxRef = useRef<HTMLDivElement>(null);
  const monthRef = useRef<HTMLDivElement>(null);
  const paymentRef = useRef<HTMLDivElement>(null);
  const printRef = useRef<HTMLDivElement>(null);
  const companyId: string = localStorage.getItem("companyId") || "";
  const locationId: string = localStorage.getItem("locationId") || "";
  const popupRef = useRef<HTMLDivElement>(null);
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
  const calculatedWidth = windowWidth / 1290;
  const [showOption, setShowOption] = useState<any>({
    check: false,
    type: "",
  });
  const path = window.location.pathname;
  const hasLoadedPageRef = useRef<Set<number>>(new Set());
  const hasLoadedClientPageRef = useRef<Set<number>>(new Set());
  const scrollProductRef = useRef<HTMLDivElement>(null);
  const scrollClientRef = useRef<HTMLDivElement>(null);
  // Active client search term (name or business number). Kept in a ref so the
  // infinite-scroll loader keeps paging within the SAME filtered result set
  // instead of silently appending unfiltered clients.
  const clientSearchRef = useRef<string>("");
  const clientSearchTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  // Reveals the full, rarely-needed billing fields (phone, tax code, address).
  // Collapsed by default so the screen stays focused on the line items.
  const [showBillingDetails, setShowBillingDetails] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState({
    client: true,
    product: true,
  });
  const [loading, setLoading] = useState({
    client: false,
    product: false,
  });
  const PAGE_SIZE = 10;
  const id: string = path.split("/").pop() || "";
  const [filter, setFilter] = useState<any>({
    page: 1,
    pageProduct: 1,
    pageClient: 1,
    limit: 50,
    sort: "DESC",
    searchProduct: "",
    searchClient: "",
  });
  const [startDate, setStartDate] = useState(new Date());
  const getTaxes = async () => {
    const responseTax = await getTax(filter);
    setListTax(responseTax.data);
    return responseTax.data;
  };

  const fetchClients = async (page: any, search: any) => {
    try {
      const response: any = await getClients(
        page,
        PAGE_SIZE,
        search,
        companyId,
        1,
      );
      return response.data.data;
    } catch (error) {
      console.error("Error loading terms:", error);
    }
  };

  const handleFormatProductPrices = async (product: any, isFirstPage = false) => {
    let tax: any = {};
    if (isFirstPage) {
      tax = await getTaxes();
    }
    let allProductPrices: any = product.flatMap((item: any, i: any) => {
      return (item.productPrices ?? []).map((val: any, index: any) => {
        const product: any = {
          recordType: 1,
          articleId: item.id,
          itemName: item.productName,
          quantity: 1,
          price: parseFloat(val.price).toFixed(2),
          discount: 0,
          sku: item.sku,
          type: item.type,
          net: 0,
          tax: getPrimaryTax(tax, val.taxGroupId),
          amount: parseFloat(val.price).toFixed(2),
          cost: parseFloat(val.cost),
          taxId: val.taxGroupId,
          productPriceId: val.id,
          note: "",
          isActive: val.isActive,
          isDeleted: val.isDeleted,
          createdBy: val.createdBy,
          updatedAt: val.updatedAt,
        };
        if (id !== "new") {
          product.salesId = id;
        }
        return product;
      });
    });
    return allProductPrices;
  };

  const productFetch = React.useCallback(
    async ({
      page,
      search,
      limit,
      signal,
    }: {
      page: number;
      search: string;
      limit: number;
      signal?: AbortSignal;
    }) => {
      const res = await getListProduct(page, limit, search, companyId);
      const arr = res?.data?.productWithCompany ?? [];
      const formatted = await handleFormatProductPrices(arr, page === 1);
      if (signal?.aborted) return { data: [], hasMore: false };
      return { data: formatted, hasMore: arr.length >= limit };
    },
    [companyId]
  );
  const asyncProduct = useAsyncDropdown({
    fetchFn: productFetch,
    limit: PAGE_SIZE,
    getItemId: (item: any) => item.productPriceId ?? item.articleId ?? "",
    resetDeps: [companyId],
  });

  const fetchProduct = async (page: any, searchValue: any) => {
    const response: any = await getListProduct(
      page,
      PAGE_SIZE,
      searchValue,
      companyId,
    );
    const array: any = response.data.productWithCompany;
    return array;
  };

  const handleSearchClient = async (e: any) => {
    e.preventDefault();
    setLoading((prev) => ({ ...prev, client: true }));
    setFilter((prev: any) => ({
      ...prev,
      pageClient: 1,
      searchClient: "",
    }));
    const allClients = await fetchClients(1, e.target.value);
    setClients(allClients);
    setHasMore((prev) => ({ ...prev, client: true }));
    setLoading((prev) => ({ ...prev, client: false }));
  };

  const onLoadMoreClient = async () => {
    if (hasMore.client && hasLoadedClientPageRef.current.has(filter.pageClient))
      return;
    hasLoadedClientPageRef.current.add(filter.pageClient);
    setLoading((prev) => ({ ...prev, client: true }));
    try {
      const allClient = await fetchClients(
        filter.pageClient,
        clientSearchRef.current,
      );
      setFilter((prev: any) => ({
        ...prev,
        pageClient: filter.pageClient + 1,
        searchClient: filter.searchClient,
      }));
      setClients((prev: any) => [...prev, ...allClient]);
      if (allClient.length < PAGE_SIZE) {
        setHasMore((prev) => ({ ...prev, client: false }));
      } else {
        setHasMore((prev) => ({ ...prev, client: true }));
      }
    } catch (err) {
      console.error(err);
      hasLoadedClientPageRef.current.delete(filter.pageClient);
    } finally {
      setLoading((prev) => ({ ...prev, client: false }));
    }
  };

  // Server-side, partial client lookup by company name OR business number.
  // Debounced so each keystroke doesn't fire a request; resets paging so the
  // dropdown shows the freshest matches and can still scroll for more.
  const handleClientServerSearch = (value: string) => {
    const term = value ?? "";
    clientSearchRef.current = term;
    if (clientSearchTimer.current) clearTimeout(clientSearchTimer.current);
    clientSearchTimer.current = setTimeout(async () => {
      setLoading((prev) => ({ ...prev, client: true }));
      try {
        const matches = (await fetchClients(1, term)) ?? [];
        hasLoadedClientPageRef.current = new Set([1]);
        setClients(matches);
        setFilter((prev: any) => ({ ...prev, pageClient: 2 }));
        setHasMore((prev) => ({
          ...prev,
          client: matches.length >= PAGE_SIZE,
        }));
      } catch (err) {
        console.error(err);
      } finally {
        setLoading((prev) => ({ ...prev, client: false }));
      }
    }, 300);
  };

  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
  }, [window, window.languageContext]);
  // Escape closes the payment drawer, matching the backdrop-click dismissal.
  useEffect(() => {
    if (!showPayment) return;
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") setShowPayment(false);
    };
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [showPayment]);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const convertToSaleDetailsPayload = (data: any[]) => {
    return data.map((item, index: any) => {
      const payload: any = {
        id: item?.id ? item?.id : "123e4567-e89b-12d3-a456-426614174000",
        salesId: item.salesId,
        sequenceNo: index,
        recordType: item.recordType,
        articleId: item.articleId,
        sku: item.sku,
        itemName: item.itemName,
        quantity: item.quantity ? item.quantity : 1,
        price: parseFloat(item.price),
        code: item.code,
        discount: item.discount ? parseFloat(item.discount) : 0,
        net:
          id === "new"
            ? parseFloat((item.amount / (1 + item.tax / 100)).toFixed(2))
            : item?.net,
        tax:
          id === "new"
            ? parseFloat(
              (item.amount - item.amount / (1 + item.tax / 100)).toFixed(2),
            )
            : item?.tax,
        amount: item.amount ? parseFloat(item.amount) : 0,
        cost: item.cost ? parseFloat(item.cost) : 0,
        taxId: item.taxId,
        productPriceId: item.productPriceId,
        note: item.note,
        isActive: item.isActive,
        isDeleted: item.isDeleted,
        createdBy: item.createdBy,
        updatedAt: item.updatedAt ? new Date(item.updatedAt) : new Date(),
      };
      if (item.recordType === 1) {
        const result: any = {
          ...payload,
          type: item.type,
        };
        return result;
      } else {
        return payload;
      }
    });
  };
  const getPrimaryTax = (dataTax: any, id: any) => {
    const taxes = Array.isArray(dataTax) ? dataTax : dataTax?.data ?? [];
    if (!id || taxes.length === 0) return "";
    return taxes.find((val: any) => val.taxGroupId === id)?.primaryRate ?? "";
  };
  const getTerms = async (termId: string | null) => {
    try {
      const response = await loadTerm(filter);
      const value: any = response.data;
      setPayemnt(value.data);
      const count: any = value.data.filter(
        (term: any) => term.isDefault === true,
      );
      if (count.length === 1) {
        setFormValues((prev: any) => ({ ...prev, termId: count[0]?.id }));
        setSearchTerm(count[0]?.termName);
      }
      if (id !== "new") {
        const term: any = value.data.find((value: any) => value.id === termId);
        setFormValues((prev: any) => ({ ...prev, termId: term?.id }));
        setSearchTerm(term?.termName);
      }
    } catch (error) {
      console.error("Error loading terms:", error);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsClientDropdownOpen(false);
      }
      if (
        dropdownPaymentRef.current &&
        !dropdownPaymentRef.current.contains(event.target as Node)
      ) {
        setIsPaymentDropdownOpen(false);
      }
      if (
        paymentRef.current &&
        !paymentRef.current.contains(event.target as Node)
      ) {
        setIsTypeDropdownOpen(false);
      }
      if (
        dropdownTaxRef.current &&
        !dropdownTaxRef.current.contains(event.target as Node)
      ) {
        setIsTypeDropdownOpen(false);
      }
      if (
        monthRef.current &&
        !monthRef.current.contains(event.target as Node)
      ) {
        setIsMonthDropdownOpen(false);
      }
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setIsModalOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.addEventListener("mousedown", handleClickOutside);
  }, []);
  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  useEffect(() => {
    if (showPayment) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPayment]);
  useEffect(() => {
    if (id !== "new") {
      fetchData(id);
    }
    const handleNewToken = () => {
      if (id !== "new") {
        fetchData(id);
      }
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, [path]);
  useEffect(() => {
    getListPayment();
    onLoadMoreClient();
    if (id === "new") {
      getListTransactionMonth("");
      getTerms("");
      getInvoice();
    }
    const handleNewToken = () => {
      getListPayment();
      onLoadMoreClient();
      if (id === "new") {
        getTerms("");
        getListTransactionMonth("");
        getInvoice();
      }
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, []);
  const getListPayment = async () => {
    try {
      const payment: any = await getPaymentType();
      setListPayment(payment?.data?.data);
    } catch (error) {
      console.log("🚀 ~ getListPayment ~ error:", error);
    }
  };
  const getInvoice = async () => {
    const res: any = await getInvoiceNumber();
    setFormValues((prev: any) => ({
      ...prev,
      invoiceNumber: res?.data?.invoiceNumber,
    }));
  };
  const getListProductWithId = async (
    dataTax: any,
    dataPurchaseDetails: any,
  ) => {
    try {
      setListTax(dataTax);
      const filteredData = dataPurchaseDetails.filter(
        (record: any) => record.recordType === 1,
      );
      const result = filteredData.reduce(
        (acc: { [key: string]: string }, item: any, index: number) => {
          acc[index.toString()] = item.itemName;
          return acc;
        },
        {},
      );
      setSearchProductPrice(result);
    } catch (error) {
      console.error("Error loading terms:", error);
    }
  };
  const fetchData = async (id: string) => {
    webLoadingTrue();
    try {
      const response: any = await getDetailSales(id);
      setFormValues({
        ...response.data,
        clientId: response.data?.clientDetail?.id,
        companyId: response.data?.clientDetail?.companyId,
        companyNumber: response.data?.clientDetail?.companyNumber,
      });
      setSearchClient(response.data?.clientDetail?.companyName);
      getTerms(response.data.termId);
      setRows(response?.data?.saleDetails);
      getListTransactionMonth(response.data.transactionMonthsId);
      const filteredData = response?.data?.saleDetails.filter(
        (record: any) => record.recordType === 2,
      );
      const responseTax: any = await getTax(filter);
      setListTax(responseTax?.data);
      const taxRateMap = responseTax?.data.reduce(
        (acc: { [key: string]: string }, item: any) => {
          acc[item.id] = item.primaryRate;
          return acc;
        },
        {},
      );

      const result = filteredData.reduce(
        (acc: { [key: string]: string }, item: any, index: number) => {
          const taxId = item.taxId;
          const primaryRate = taxRateMap[taxId];
          if (primaryRate) {
            acc[index.toString()] = primaryRate;
          }
          return acc;
        },
        {},
      );
      setSearchTaxMap(result);
      getListProductWithId(responseTax?.data, response?.data?.saleDetails);
      setFormValuesPayment({
        salePayment: response?.data?.salePayment,
      });
    } catch (error) {
      console.error("Error loading terms:", error);
    } finally {
      webLoadingFalse();
    }
  };
  const handleSelectType = (type: "product" | "service") => {
    setIsModalOpen(false);
    const isPreviousValid =
      rows.length > 0 &&
      rows[rows.length - 1] &&
      rows[rows.length - 1].sku !== "" &&
      rows[rows.length - 1].itemName !== "" &&
      rows[rows.length - 1].price !== "" &&
      rows[rows.length - 1].tax !== "" &&
      rows[rows.length - 1].discount !== "" &&
      rows[rows.length - 1].amount !== "";
    let newRow: any = {};
    if (type === "product") {
      newRow = {
        sequenceNo: rows.length + 1,
        recordType: 1,
        articleId: "123e4567-e89b-12d3-a456-426614174000",
        quantity: 1,
        price: "",
        sku: "",
        code: "",
        net: 0,
        discount: "",
        tax: "",
        amount: "",
        taxId: "123e4567-e89b-12d3-a456-426614174000",
        productPriceId: "123e4567-e89b-12d3-a456-426614174000",
        note: "",
        isActive: true,
        isDeleted: false,
        createdBy: "123e4567-e89b-12d3-a456-426614174000",
        updatedAt: new Date(),
      };
      if (id !== "new") {
        newRow.salesId = id;
      }
    } else {
      newRow = {
        sequenceNo: rows.length + 1,
        recordType: 2,
        articleId: null,
        quantity: 1,
        price: "",
        sku: "",
        code: "",
        net: 0,
        discount: "",
        tax: "",
        amount: "",
        taxId: "123e4567-e89b-12d3-a456-426614174000",
        productPriceId: "123e4567-e89b-12d3-a456-426614174000",
        note: "",
        isActive: true,
        isDeleted: false,
        createdBy: "123e4567-e89b-12d3-a456-426614174000",
        updatedAt: new Date(),
      };
      if (id !== "new") {
        newRow.salesId = id;
      }
    }
    if (isPreviousValid || rows.length === 0) {
      const newIndex = rows.length;
      setRows((prevRows) => [...prevRows, newRow]);
      setAutoFocusIndex(newIndex);
    }
  };
  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormValues({ ...formValues, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };
  const handlePaymentChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormValuesPayment({ ...formValuesPayment, [name]: value });
  };
  const getListTransactionMonth = async (
    transactionMonthsId: string | null,
  ) => {
    try {
      const response: any = await getTransactionMonth(locationId, companyId);
      setListMonths(response.data);
      if (id !== "new" && transactionMonthsId) {
        const month: any = response.data.find(
          (value: any) => value.id === transactionMonthsId,
        );
        if (month) {
          setSelectedMonth(
            String(month.transactionYear + " - " + month.monthSequence),
          );
          setFormValues((prev: any) => ({
            ...prev,
            transactionMonthsId: month.id,
          }));
        }
      } else if (id === "new" && response.data?.length > 0) {
        const sorted = [...response.data].sort(
          (a: any, b: any) =>
            new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime(),
        );
        const month = sorted[0];
        setSelectedMonth(
          String(month.transactionYear + " - " + month.monthSequence),
        );
        setFormValues((prev: any) => ({
          ...prev,
          transactionMonthsId: month.id,
        }));
      }
    } catch (error) {
      console.error("Error loading terms:", error);
    }
  };
  const handleClientSelect = (client: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      clientId: client?.id,
      companyId: client?.company?.id,
      companyNumber: client?.company?.companyNumber,
      emailAddress: client?.emailAddress,
      phoneNumber: client?.phoneNumber,
      taxCode: client?.taxCode,
      businessAddress: [
        client?.companyName,
        client?.addressLine1,
        client?.addressLine2,
        client?.city,
        client?.postalCode,
        client?.countryName,
      ]
        .filter((value) => value != null)
        .join(" , "),
    }));
    setSearchClient(client?.companyName);
    // Keep the full record for the customer-context row (account-summary fields).
    setSelectedClient(client);
    // Default Payment Term, only when the client record carries one. Guarded so
    // it is a no-op (never clears a manual choice) until the API exposes it.
    const defaultTermId = client?.paymentTerm?.id ?? client?.paymentTermId;
    const defaultTermName = client?.paymentTerm?.termName ?? client?.paymentTermName;
    if (defaultTermId && defaultTermName) {
      setFormValues((prev: any) => ({ ...prev, termId: defaultTermId }));
      setSearchTerm(defaultTermName);
    }
    setErrors({
      ...errors,
      clientId: "",
      companyNumber: "",
      emailAddress: "",
      phoneNumber: "",
      taxCode: "",
      businessAddress: "",
    });
    setIsClientDropdownOpen(false);
  };
  const handleProductSelect = (product: any, index: any) => {
    const arrayTemp: any = [...rows];
    arrayTemp[index] = {
      ...product,
      discount: (0).toFixed(2),
      sequenceNo: index,
    };
    setRows(arrayTemp);
    setSearchProductPrice((prev: any) => ({
      ...prev,
      [index]: product.itemName,
    }));
    setIsProductPriceDropdownOpen((prev) => ({ ...prev, [index]: false }));
  };
  const handleProductPriceDropdownToggle = (index: number) => {
    setIsProductPriceDropdownOpen((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const handlePaymentTypeSelect = (status: any) => {
    setFormValuesPayment((prev: any) => ({
      ...prev,
      type: status.paymentName,
    }));
    setPayemntType(status.paymentName);
    setIsTypeDropdownOpen(false);
  };
  const handlePaymentSelect = (termId: string, termName: string) => {
    setFormValues((prev: any) => ({ ...prev, termId: termId }));
    setSearchTerm(termName);
    setIsPaymentDropdownOpen(false);
  };
  const handleStartDate = (value: any) => {
    setStartDate(value);
    setFormValues({ ...formValues, issuedOn: value });
  };
  const handleDelete = (index: number) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    setSearchProductPrice((prev: any) => ({ ...prev, [index]: "" }));
  };
  const handleQuantityChange = (
    index: number,
    type: "increment" | "decrement",
  ) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const row = { ...updatedRows[index] };

      if (type === "increment") {
        row.quantity += 1;
      } else if (type === "decrement" && row.quantity > 0) {
        row.quantity -= 1;
      }

      row.amount = calculateServiceTotal(row);
      updatedRows[index] = row;

      return updatedRows;
    });
  };
  const calculateServiceTotal = (row: saleDetailsPayload) => {
    return (
      Number(row.quantity) * Number(row.price) -
      (Number(row.discount) ? Number(row.discount) : 0)
    );
  };
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const newQuantity = Number(e.target.value);

    if (isNaN(newQuantity) || newQuantity < 0) {
      return;
    }

    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const row = { ...updatedRows[index] };

      row.quantity = newQuantity;
      row.amount = calculateServiceTotal(row);

      updatedRows[index] = row;

      return updatedRows;
    });
  };
  const handleInputServiceChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    field: string,
  ) => {
    const value = e.target.value;
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const row = { ...updatedRows[index] };
      row[field] = value;
      row.amount = calculateServiceTotal(row);
      updatedRows[index] = row;
      return updatedRows;
    });
  };
  const handleBlurServiceChange = (
    e: React.FocusEvent<HTMLInputElement, Element>,
    index: number,
    field: string,
  ) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const row = { ...updatedRows[index] };
      row[field] = Number(row[field]).toFixed(2);
      updatedRows[index] = row;
      return updatedRows;
    });
  };
  const handleTaxDropdownToggle = (index: number) => {
    setOpenDropdownIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const handleTaxSelect = (tax: any, index: number) => {
    const updatedRows = [...rows];
    updatedRows[index] = {
      ...updatedRows[index],
      tax: tax.primaryRate,
      taxId: tax.id,
    };
    setRows(updatedRows);
    setSearchTaxMap((prev: any) => ({ ...prev, [index]: tax.primaryRate }));
    setOpenDropdownIndexes((prev) => ({ ...prev, [index]: false }));
  };
  const handleMonthSelect = (month: any) => {
    setSelectedMonth(
      String(month.transactionYear + " - " + month.monthSequence),
    );
    const fromDate = new Date(month.fromDate);
    setFormValues((prev: any) => ({ ...prev, transactionMonthsId: month.id }));
    setIsMonthDropdownOpen(false);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleOpenPopup = () => {
    setShowPopup(true);
  };
  // Surface a failed save through the shared plain-language error layer: it maps
  // the backend error to a friendly "what happened + what to do" message, applies
  // any field errors, and keeps the endpoint + status as a muted secondary line.
  const showApiError = (error: any, title: string) =>
    showApiErrorToast(error, {
      language,
      titleFallback: title,
      setFieldErrors: (fe) => setErrors((prev: any) => ({ ...prev, ...fe })),
    });
  const handleSubmit = async (
    e: React.ChangeEvent<HTMLInputElement>,
    type: string,
  ) => {
    e.preventDefault();
    const newErrors: any = {};
    if (!formValues.clientId) {
      newErrors.clientId = "Client is required";
    }
    if (!formValues.companyNumber) {
      newErrors.companyNumber = "NUI is required";
    }
    if (!formValues.emailAddress) {
      newErrors.emailAddress = "Email Address is required";
    }
    if (!formValues.transactionMonthsId) {
      newErrors.transactionMonthsId = "Accounting Period is required";
    }
    if (!formValues.invoiceNumber) {
      newErrors.invoiceNumber = "Invoice No is required";
    }
    if (!formValues.termId) {
      newErrors.termId = "Payment Term is required";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    if (locationId === "") {
      handleOpenPopup();
      return;
    }
    const cleanedFormValues =
      id !== "new"
        ? (() => {
          const { clientDetail, ...rest } = formValues;
          return rest;
        })()
        : formValues;
    const payload = {
      ...cleanedFormValues,
      clientId: formValues?.clientId,
      salesType: "product",
      reference: formValues?.reference,
      issuedOn: formValues?.issuedOn ? formValues?.issuedOn : new Date(),
      dueDate: new Date(),
      companyId: localStorage.getItem("companyId") || "",
      locationId: localStorage.getItem("locationId") || "",
      quantity: rows.reduce(
        (acc: any, val: any) => acc + Number(val.quantity ? val.quantity : 1),
        0,
      ),
      price: parseFloat(
        rows
          .reduce((acc: any, val: any) => acc + Number(val.price), 0)
          .toFixed(2),
      ),
      net: parseFloat(
        id === "new"
          ? rows
            .reduce(
              (acc: any, val: any) =>
                acc +
                (Number(val.amount) -
                  Number(val.amount) / (1 + Number(val.tax) / 100)),
              0,
            )
            .toFixed(2)
          : rows
            .reduce((acc: any, val: any) => acc + Number(val.net), 0)
            .toFixed(2),
      ),
      tax: parseFloat(
        id === "new"
          ? rows
            .reduce(
              (acc: any, val: any) =>
                acc +
                (Number(val.amount) -
                  Number(val.amount) / (1 + Number(val.tax) / 100)),
              0,
            )
            .toFixed(2)
          : rows
            .reduce((acc: any, val: any) => acc + Number(val.tax), 0)
            .toFixed(2),
      ),
      discount: parseFloat(
        rows
          .reduce((acc: any, val: any) => acc + Number(val.discount), 0)
          .toFixed(2),
      ),
      amount: parseFloat(
        rows
          .reduce((acc: any, val: any) => acc + Number(val.amount), 0)
          .toFixed(2),
      ),
      note: formValues.note,
      termId: formValues?.termId,
      invoiceNumber: formValues?.invoiceNumber,
      saleDetails: convertToSaleDetailsPayload(rows),
      type,
    };
    webLoadingTrue();
    // Payment lines post in parallel; show one error toast per submit.
    let paymentErrorShown = false;
    if (id === "new") {
      try {
        const response: any = await createSales(payload);
        if (response?.data?.id) {
          if (
            formValuesPayment?.salePayment.reduce(
              (acc: any, val: any) => acc + Number(val.amount),
              0,
            ) > 0
          ) {
            formValuesPayment?.salePayment?.map(async (val: any) => {
              const paymentPayload: any = {
                salesId: response?.data?.id,
                type: val.type,
                reference: val.reference,
                amount: Number(val?.amount),
                transactionMonthsId: formValues?.transactionMonthsId,
              };
              try {
                const check: any = await createSalesPayment(paymentPayload);
                if (check?.data?.id) {
                  showToast({
                    message: "Sale added successfully",
                    type: "success",
                    duration: 20000,
                  });
                  webNavigate("/" + preLanguage + "/sales");
                  webLoadingFalse();
                }
              } catch (error) {
                webLoadingFalse();
                handleOpenPopup();
                if (!paymentErrorShown) showApiErrorToast(error, { language });
                paymentErrorShown = true;
              }
            });
          } else {
            webNavigate("/" + preLanguage + "/sales");
            showToast({
              message: "Sale added successfully",
              type: "success",
              duration: 20000,
            });
            webLoadingFalse();
          }
        }
      } catch (error: any) {
        webLoadingFalse();
        showApiError(error, "Error creating sale");
      }
    } else {
      try {
        const response = await updateSales(id, payload);
        if (response?.data?.id) {
          if (
            formValuesPayment?.salePayment.length >
            formValues?.salePayment.length
          ) {
            formValuesPayment?.salePayment
              .slice(formValues?.salePayment.length)
              ?.map(async (val: any) => {
                const paymentPayload: any = {
                  salesId: response?.data?.id,
                  type: val.type,
                  reference: val.reference,
                  amount: Number(val?.amount),
                  transactionMonthsId: formValues?.transactionMonthsId,
                };
                try {
                  const check: any = await createSalesPayment(paymentPayload);
                  if (check?.data?.id) {
                    webNavigate("/" + preLanguage + "/sales");
                    webLoadingFalse();
                  }
                  showToast({
                    message: "Sale updated successfully",
                    type: "success",
                    duration: 20000,
                  });
                } catch (error) {
                  webLoadingFalse();
                  handleOpenPopup();
                  if (!paymentErrorShown) showApiErrorToast(error, { language });
                  paymentErrorShown = true;
                }
              });
          } else {
            showToast({
              message: "Sale updated successfully",
              type: "success",
              duration: 20000,
            });
            webNavigate("/" + preLanguage + "/sales");
            webLoadingFalse();
          }
        }
      } catch (error: any) {
        webLoadingFalse();
        showApiError(error, "Error updating sale");
      }
    }
  };

  // Guard the invoice submit against double-clicks creating duplicate sales.
  const [submitGuarded, submitting] = useSubmitGuard(handleSubmit);

  const handlePayment = async () => {
    const balace: any = (
      (formValuesPayment?.salePayment &&
        Array.isArray(formValuesPayment.salePayment)
        ? formValuesPayment.salePayment.reduce(
          (acc: number, val: any) => acc + (Number(val.amount) || 0),
          0,
        )
        : 0) -
      (Array.isArray(rows) && rows.length > 0
        ? rows.reduce(
          (acc: number, val: any) => acc + (Number(val.amount) || 0),
          0,
        )
        : 0)
    ).toFixed(2);

    if (Number(balace) + Number(formValuesPayment?.value) > 0) {
      setStatusPayment(true);
      setShowPayment(true);
    } else {
      setStatusPayment(false);
      setFormValuesPayment((prevState: any) => {
        const newSalePayment = {
          createdAt: new Date(),
          amount: formValuesPayment?.value,
          reference: formValuesPayment?.reference,
          sale_id: id !== "new" ? id : "",
          type: formValuesPayment?.type,
        };
        const shouldAddPayment = Number(formValuesPayment?.value) > 0;
        return {
          ...prevState,
          value: "0",
          reference: "",
          type: "",
          salePayment: shouldAddPayment
            ? [...(prevState.salePayment || []), newSalePayment]
            : prevState.salePayment,
        };
      });
      setPayemntType("");
      setShowPayment(false);
    }
  };
  const handleDeleteSale = async () => {
    setShowOption({
      type: "",
      check: false,
    });
    webLoadingTrue();
    try {
      const response = await updateStatus(id, {
        type: showOption?.type === "Cancel" ? "canceled" : "rejected ",
      });
    } catch (error) {
      console.error("Error loading terms:", error);
      showApiErrorToast(error, { language });
    } finally {
      webNavigate("/" + preLanguage + "/sales");
    }
  };
  const handleResetPayment = () => {
    setShowPayment(false);
    setPayemntType("");
    setFormValuesPayment({
      ...formValuesPayment,
      value: "0",
      reference: "",
      type: "",
    });
  };
  const isRowValid = (row: any) => {
    return (
      row &&
      row.sku !== "" &&
      row.itemName !== "" &&
      row.price !== "" &&
      row.tax !== "" &&
      row.discount !== "" &&
      row.amount !== ""
    );
  };
  const handleShowSave = () => {
    const areAllRowsValid = rows.map(isRowValid).every((valid) => valid);
    const isPreviousValid = rows.length > 0 && areAllRowsValid;
    if (isPreviousValid) {
      setShowSave(!showSave);
    }
  };
  // Download the invoice as a real PDF (html2pdf renders the print node), as an
  // alternative to the browser print dialog.
  const handleDownloadInvoice = () => {
    const node = printRef.current;
    if (!node) return;
    const filename = `invoice-${formValues?.invoiceNumber ?? ""}.pdf`;
    // html2pdf yields a zero-height (blank) canvas when .from() is handed a
    // position:absolute element — which the off-screen print wrapper is. Capture
    // the in-flow document node inside it instead (it inherits the wrapper width).
    const target = (node.firstElementChild as HTMLElement) ?? node;
    html2pdf()
      .set({
        margin: 8,
        filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff" },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      })
      .from(target)
      .save();
  };
  return (
    <>
      <div className=" bg-white">
        <div className="flex items-center ">
          <div
            className="w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => {
              webNavigate("/" + preLanguage + "/sales");
            }}
          >
            <BackIcon />
          </div>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "28px",
              color: "#222525",
            }}
            className="font-inter"
          >
            {language && language?.["Back"] ? language?.["Back"] : "Back"}
          </p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        {id === "new" ? (
          <p
            style={{
              margin: "20px 0px",
              fontSize: "20px",
              fontWeight: "500",
              lineHeight: "28px",
              color: "#222525",
            }}
            className="font-inter"
          >
            {language && language?.["Add Sale"]
              ? language?.["Add Sale"]
              : "Add Sale"}
          </p>
        ) : (
          <p
            style={{
              margin: "20px 0px",
              fontSize: "20px",
              fontWeight: "500",
              lineHeight: "28px",
              color: "#222525",
            }}
            className="font-inter"
          >
            {language && language?.["Edit Sale"]
              ? language?.["Edit Sale"]
              : "Edit Sale"}
          </p>
        )}
        <div className="flex items-center" style={{ gap: "16px" }}>
          {/* Invoice number is the document's primary identifier, so it sits
              top-right in bold rather than buried among the contact fields. */}
          <div className="flex flex-col items-end">
            <p
              className="font-inter"
              style={{ fontSize: "12px", lineHeight: "16px", color: "#6A7878" }}
            >
              {language && language?.["Invoice No"]
                ? language?.["Invoice No"]
                : "Invoice No"}
            </p>
            <p
              className="font-inter"
              style={{
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "26px",
                color: "#222525",
              }}
            >
              {formValues?.invoiceNumber || "—"}
            </p>
          </div>
          <TagStatus value={formValues?.status?.statusName} />
          {/* Print is hidden on create: an invoice must be saved before it can
              be printed (no draft-print support). It returns once id !== "new". */}
          {id !== "new" && (
          <>
          <div
            role="button"
            tabIndex={0}
            className="cursor-pointer flex items-center no-print"
            style={{
              padding: "8px 16px",
              gap: "8px",
              border: "1px solid #0F7679",
              borderRadius: "30px",
            }}
            onClick={() => window.print()}
            onKeyDown={(e) => e.key === "Enter" && window.print()}
          >
            <div
              className="flex items-center justify-center"
              style={{ width: "24px", height: "24px" }}
            >
              <PrintIcon />
            </div>
            <p
              className="text-[14px] leading-[22px] font-inter"
              style={{ color: "#0F7679", fontWeight: "500" }}
            >
              {language && language?.["Print"] ? language?.["Print"] : "Print"}
            </p>
          </div>
          <div
            role="button"
            tabIndex={0}
            className="cursor-pointer flex items-center justify-center no-print"
            style={{
              padding: "8px 16px",
              backgroundColor: "#0F7679",
              borderRadius: "30px",
            }}
            onClick={handleDownloadInvoice}
            onKeyDown={(e) => e.key === "Enter" && handleDownloadInvoice()}
          >
            <p
              className="text-[14px] leading-[22px] font-inter"
              style={{ color: "#FFFFFF", fontWeight: "500" }}
            >
              {language && language?.["Download PDF"]
                ? language?.["Download PDF"]
                : "Download PDF"}
            </p>
          </div>
          </>
          )}
        </div>
      </div>
      <div className="" style={{ height: "calc(100% - 96px - 67px)" }}>
        <form
          className="scroll-container"
          style={{ height: "100%", overflowY: "scroll", paddingBottom: '16px' }}
        >
          {/* ===== Bill to ===== */}
          <div
            style={{
              padding: "24px",
              border: "1px solid #DBE4E4",
              borderRadius: "12px",
            }}
          >
            <div
              className="flex items-center justify-between"
              style={{ marginBottom: "16px", gap: "12px" }}
            >
              <p
                className="text-main font-inter leading-[24px]"
                style={{ fontSize: "16px", fontWeight: "500" }}
              >
                {language && language?.["Bill to"]
                  ? language?.["Bill to"]
                  : "Bill to"}
              </p>
              {formValues?.clientId && (
                <button
                  type="button"
                  onClick={() => setShowBillingDetails((v) => !v)}
                  className="font-inter no-print"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#0F7679",
                    background: "transparent",
                  }}
                >
                  {showBillingDetails
                    ? language && language?.["Hide billing details"]
                      ? language?.["Hide billing details"]
                      : "Hide billing details"
                    : language && language?.["Edit billing details"]
                      ? language?.["Edit billing details"]
                      : "Edit billing details"}
                </button>
              )}
            </div>

            {/* Client selector — searchable by company name or business number */}
            <div
              className="space-y-2"
              style={{ width: isMobile ? "100%" : "calc(60% - 12px)" }}
            >
              <div className="flex items-center">
                <p
                  className="text-[14px] font-inter leading-[20px]"
                  style={{ color: "#4A5353", fontWeight: "500" }}
                >
                  {language && language?.["Client"]
                    ? language?.["Client"]
                    : "Client"}
                </p>
                <p
                  className="text-[14px] font-inter leading-[20px] font-medium"
                  style={{ color: "#BA0E13" }}
                >
                  *
                </p>
              </div>
              <div className="w-full">
                <DropdownSearch
                  refKey="client"
                  refs={{ client: dropdownRef }}
                  openStates={{ client: isClientDropdownOpen }}
                  open={() => setIsClientDropdownOpen(true)}
                  close={() => setIsClientDropdownOpen(false)}
                  data={clients}
                  labelExtractor={(item) => item.companyName}
                  value={searchClient}
                  setValue={setSearchClient}
                  onSelect={handleClientSelect}
                  onSearch={handleClientServerSearch}
                  serverSideSearch
                  placeholder={
                    language && language?.["Search by name or business number"]
                      ? language?.["Search by name or business number"]
                      : "Search by name or business number"
                  }
                  error={errors.clientId}
                  tabIndex={0}
                  onLoadMore={onLoadMoreClient}
                  hasMore={hasMore.client}
                  loading={loading.client}
                />
              </div>

              {/* Business number under the client name, in smaller font */}
              {formValues?.clientId && formValues?.companyNumber && (
                <p
                  className="font-inter"
                  style={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    color: "#6A7878",
                  }}
                >
                  {(language && language?.["Business no."]
                    ? language?.["Business no."]
                    : "Business no.") + " "}
                  <span style={{ color: "#4A5353", fontWeight: 500 }}>
                    {formValues.companyNumber}
                  </span>
                  {formValues?.taxCode ? (
                    <>
                      {"  ·  " +
                        (language && language?.["TAX No"]
                          ? language?.["TAX No"]
                          : "TAX No") +
                        " "}
                      <span style={{ color: "#4A5353", fontWeight: 500 }}>
                        {formValues.taxCode}
                      </span>
                    </>
                  ) : null}
                </p>
              )}

              {/* Compact customer-account context. Renders only when the selected
                  client carries account-summary fields. */}
              {selectedClient &&
                (selectedClient.outstandingBalance != null ||
                  selectedClient.overdueInvoicesCount != null ||
                  selectedClient.creditAvailable != null ||
                  selectedClient.lastInvoiceDate != null) && (
                  <div
                    className="flex items-center"
                    style={{ gap: "12px", flexWrap: "wrap", marginTop: "2px" }}
                  >
                    {selectedClient.outstandingBalance != null && (
                      <span
                        className="text-[12px] font-inter"
                        style={{ color: "#6A7878" }}
                      >
                        {(language && language?.["Outstanding"]
                          ? language?.["Outstanding"]
                          : "Outstanding") + ": "}
                        <span style={{ color: "#222525", fontWeight: 500 }}>
                          {Number(selectedClient.outstandingBalance).toFixed(2)} €
                        </span>
                      </span>
                    )}
                    {selectedClient.overdueInvoicesCount != null && (
                      <span
                        className="text-[12px] font-inter"
                        style={{ color: "#6A7878" }}
                      >
                        {(language && language?.["Overdue"]
                          ? language?.["Overdue"]
                          : "Overdue") + ": "}
                        <span style={{ color: "#222525", fontWeight: 500 }}>
                          {selectedClient.overdueInvoicesCount}
                        </span>
                      </span>
                    )}
                    {selectedClient.creditAvailable != null && (
                      <span
                        className="text-[12px] font-inter"
                        style={{ color: "#6A7878" }}
                      >
                        {(language && language?.["Credit"]
                          ? language?.["Credit"]
                          : "Credit") + ": "}
                        <span style={{ color: "#222525", fontWeight: 500 }}>
                          {Number(selectedClient.creditAvailable).toFixed(2)} €
                        </span>
                      </span>
                    )}
                    {selectedClient.lastInvoiceDate != null && (
                      <span
                        className="text-[12px] font-inter"
                        style={{ color: "#6A7878" }}
                      >
                        {(language && language?.["Last Invoice"]
                          ? language?.["Last Invoice"]
                          : "Last Invoice") + ": "}
                        <span style={{ color: "#222525", fontWeight: 500 }}>
                          {formatDate(selectedClient.lastInvoiceDate)}
                        </span>
                      </span>
                    )}
                  </div>
                )}
            </div>

            {/* Required billing fields are surfaced inline only when the selected
                client is missing them. Otherwise they stay out of the way. */}
            {formValues?.clientId &&
              !showBillingDetails &&
              (!formValues?.companyNumber || !formValues?.emailAddress) && (
                <div
                  style={{
                    marginTop: "16px",
                    padding: "12px 16px",
                    borderRadius: "12px",
                    backgroundColor: "#FBEAEA",
                  }}
                >
                  <p
                    className="font-inter"
                    style={{
                      fontSize: "12px",
                      color: "#BA0E13",
                      marginBottom: "12px",
                    }}
                  >
                    {language && language?.["Missing required billing details"]
                      ? language?.["Missing required billing details"]
                      : "This client is missing details required to post the invoice. Complete them below."}
                  </p>
                  <div
                    className="flex items-start"
                    style={{ gap: "24px", flexWrap: "wrap" }}
                  >
                    {!formValues?.companyNumber && (
                      <div
                        className="space-y-2"
                        style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                      >
                        <div className="flex items-center">
                          <p
                            className="text-[14px] font-inter leading-[20px]"
                            style={{ color: "#4A5353", fontWeight: "500" }}
                          >
                            {language && language?.["Business NUI"]
                              ? language?.["Business NUI"]
                              : "Business NUI"}
                          </p>
                          <p
                            className="text-[14px] font-inter leading-[20px] font-medium"
                            style={{ color: "#BA0E13" }}
                          >
                            *
                          </p>
                        </div>
                        <input
                          type="text"
                          name="companyNumber"
                          required
                          onKeyDown={validateNoSpecialCharsOrSpaces}
                          value={formValues?.companyNumber}
                          onChange={(e: any) => handleChange(e)}
                          className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full`}
                        />
                        {errors.companyNumber && (
                          <p className="error">{errors.companyNumber}</p>
                        )}
                      </div>
                    )}
                    {!formValues?.emailAddress && (
                      <div
                        className="space-y-2"
                        style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                      >
                        <div className="flex items-center">
                          <p
                            className="text-[14px] font-inter leading-[20px]"
                            style={{ color: "#4A5353", fontWeight: "500" }}
                          >
                            {language && language?.["Email"]
                              ? language?.["Email"]
                              : "Email"}
                          </p>
                          <p
                            className="text-[14px] font-inter leading-[20px] font-medium"
                            style={{ color: "#BA0E13" }}
                          >
                            *
                          </p>
                        </div>
                        <input
                          type="text"
                          name="emailAddress"
                          value={formValues?.emailAddress}
                          onChange={(e: any) => handleChange(e)}
                          className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full`}
                        />
                        {errors.emailAddress && (
                          <p className="error">{errors.emailAddress}</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

            {/* Full billing fields — collapsed by default to keep the focus on
                line items; opened with "Edit billing details". */}
            {showBillingDetails && (
              <div
                className="flex items-start"
                style={{ gap: "24px", flexWrap: "wrap", marginTop: "16px" }}
              >
                <div
                  className="space-y-2"
                  style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                >
                  <div className="flex items-center">
                    <p
                      className="text-[14px] font-inter leading-[20px]"
                      style={{ color: "#4A5353", fontWeight: "500" }}
                    >
                      {language && language?.["Email"]
                        ? language?.["Email"]
                        : "Email"}
                    </p>
                    <p
                      className="text-[14px] font-inter leading-[20px] font-medium"
                      style={{ color: "#BA0E13" }}
                    >
                      *
                    </p>
                  </div>
                  <input
                    type="text"
                    name="emailAddress"
                    value={formValues?.emailAddress}
                    onChange={(e: any) => handleChange(e)}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full`}
                  />
                  {errors.emailAddress && (
                    <p className="error">{errors.emailAddress}</p>
                  )}
                </div>
                <div
                  className="space-y-2"
                  style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                >
                  <div className="flex items-center">
                    <p
                      className="text-[14px] font-inter leading-[20px]"
                      style={{ color: "#4A5353", fontWeight: "500" }}
                    >
                      {language && language?.["Business NUI"]
                        ? language?.["Business NUI"]
                        : "Business NUI"}
                    </p>
                    <p
                      className="text-[14px] font-inter leading-[20px] font-medium"
                      style={{ color: "#BA0E13" }}
                    >
                      *
                    </p>
                  </div>
                  <input
                    type="text"
                    name="companyNumber"
                    required
                    onKeyDown={validateNoSpecialCharsOrSpaces}
                    value={formValues?.companyNumber}
                    onChange={(e: any) => handleChange(e)}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full`}
                  />
                  {errors.companyNumber && (
                    <p className="error">{errors.companyNumber}</p>
                  )}
                </div>
                <div
                  className="space-y-2"
                  style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                >
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Phone Number"]
                      ? language?.["Phone Number"]
                      : "Phone Number"}
                  </p>
                  <input
                    type="text"
                    name="phoneNumber"
                    value={formValues?.phoneNumber}
                    onKeyDown={validatePhoneNumber}
                    onChange={(e: any) => handleChange(e)}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                <div
                  className="space-y-2"
                  style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
                >
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["TAX No"]
                      ? language?.["TAX No"]
                      : "TAX No"}
                  </p>
                  <input
                    type="text"
                    name="taxCode"
                    onKeyDown={validateNoSpecialCharsOrSpaces}
                    value={formValues?.taxCode}
                    onChange={(e: any) => handleChange(e)}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                <div className="space-y-2 w-full">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Business Address"]
                      ? language?.["Business Address"]
                      : "Business Address"}
                  </p>
                  <textarea
                    value={formValues?.businessAddress}
                    onKeyDown={validateNoSpecialChars}
                    name="businessAddress"
                    style={{ height: "88px" }}
                    onChange={(e: any) => handleChange(e)}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full`}
                  />
                  {errors.businessAddress && (
                    <p className="error">{errors.businessAddress}</p>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* ===== Invoice details (accounting period, reference, dates, terms) ===== */}
          <div
            style={{
              marginTop: "16px",
              padding: "24px",
              border: "1px solid #DBE4E4",
              borderRadius: "12px",
            }}
          >
            <p
              className="text-main font-inter leading-[24px]"
              style={{ fontSize: "16px", fontWeight: "500", marginBottom: "16px" }}
            >
              {language && language?.["Invoice details"]
                ? language?.["Invoice details"]
                : "Invoice details"}
            </p>
            <div
              className="flex items-start"
              style={{ gap: "24px", flexWrap: "wrap" }}
            >
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Accounting Period"]
                      ? language?.["Accounting Period"]
                      : "Accounting Period"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: "#BA0E13" }}
                  >
                    *
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="month"
                    refs={{ month: monthRef }}
                    openStates={{ month: isMonthDropdownOpen }}
                    open={(key) =>
                      key === "month" && setIsMonthDropdownOpen(true)
                    }
                    close={(key) =>
                      key === "month" && setIsMonthDropdownOpen(false)
                    }
                    data={listMonths}
                    labelExtractor={(item) =>
                      `${item.transactionYear} - ${item.monthSequence}`
                    }
                    value={selectedMonth}
                    setValue={setSelectedMonth}
                    onSelect={handleMonthSelect}
                    tabIndex={0}
                  />
                </div>
                {errors.transactionMonthsId ? (
                  <p className="error">{errors.transactionMonthsId}</p>
                ) : (
                  <p
                    className="text-[12px] font-inter leading-[16px]"
                    style={{ color: "#6A7878" }}
                  >
                    {language && language?.["Accounting period helper"]
                      ? language?.["Accounting period helper"]
                      : "Period this invoice posts to. Usually matches the invoice date."}
                  </p>
                )}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <p
                  className="text-[14px] font-inter leading-[20px]"
                  style={{ color: "#4A5353", fontWeight: "500" }}
                >
                  {language && language?.["Reference"]
                    ? language?.["Reference"]
                    : "Reference"}
                </p>
                <input
                  type="text"
                  onKeyDown={validateNoSpecialCharsOrSpaces}
                  name="reference"
                  value={formValues?.reference}
                  onChange={(e: any) => handleChange(e)}
                  className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full`}
                />
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <p
                  className="text-[14px] font-inter leading-[20px]"
                  style={{ color: "#4A5353", fontWeight: "500" }}
                >
                  {language && language?.["Date"] ? language?.["Date"] : "Date"}
                </p>
                <div className="w-full">
                  <DatePicker
                    showTimeSelect
                    tabIndex={0}
                    dateFormat="dd-MM-yyyy"
                    placeholderText={
                      language && language?.["Enter Date"]
                        ? language?.["Enter Date"]
                        : "Enter Date"
                    }
                    name="startTime"
                    className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl outline-none focus-none bg-transparent w-full"
                    selected={startDate}
                    onKeyDown={validateNoSpecialCharsOrSpaces}
                    onChange={(e) => handleStartDate(e)}
                  />
                </div>
                {errors.issuedOn && <p className="error">{errors.issuedOn}</p>}
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(50% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353", fontWeight: "500" }}
                  >
                    {language && language?.["Payment Term"]
                      ? language?.["Payment Term"]
                      : "Payment Term"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: "#BA0E13" }}
                  >
                    *
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch<{ id: string; termName: string }>
                    refKey="paymentTerm"
                    refs={{ paymentTerm: dropdownPaymentRef }}
                    openStates={{ paymentTerm: isPaymentDropdownOpen }}
                    open={() => setIsPaymentDropdownOpen(true)}
                    close={() => setIsPaymentDropdownOpen(false)}
                    data={payment}
                    labelExtractor={(item) => item.termName}
                    value={searchTerm}
                    setValue={setSearchTerm}
                    onSelect={(item) =>
                      handlePaymentSelect(item.id, item.termName)
                    }
                    tabIndex={0}
                  />
                </div>
                {errors.termId && <p className="error">{errors.termId}</p>}
              </div>
            </div>
          </div>
          {/* Items */}
          <div style={{ marginTop: "24px" }}>
            <p
              className="text-main font-inter leading-[24px]"
              style={{
                fontSize: "20px",
                fontWeight: "500",
                marginBottom: "12px",
              }}
            >
              {language && language?.["Items"] ? language?.["Items"] : "Items"}
            </p>
            <div
              style={{
                border: isMobile ? "none" : "1px solid #DBE4E4",
                borderRadius: "16px",
                marginTop: "12px",
              }}
            >
              {!isMobile && (
                <div
                  className="h-10 flex items-center"
                  style={{
                    backgroundColor: "#EBF0F0",
                    borderTopRightRadius: "12px",
                    borderTopLeftRadius: "12px",
                  }}
                >
                  <div
                    className="text-xs font-medium font-inter flex items-center"
                    style={{
                      color: "#6A7878",
                      fontSize: "14px",
                      padding: "0px 12px",
                      width: `${calculatedWidth * 40}px`,
                    }}
                  >
                    <p>
                      {language && language?.["No"] ? language?.["No"] : "No"}
                    </p>
                  </div>
                  <div
                    className="text-xs font-medium font-inter flex items-center"
                    style={{
                      color: "#6A7878",
                      padding: "0px 12px",
                      width: `${calculatedWidth * 132}px`,
                    }}
                  >
                    <p>
                      {language && language?.["Code"]
                        ? language?.["Code"]
                        : "Code"}
                    </p>
                  </div>
                  <div
                    className="text-xs font-medium font-inter flex items-center"
                    style={{
                      color: "#6A7878",
                      padding: "0px 12px",
                      flexGrow: 1,
                    }}
                  >
                    <p>
                      {language && language?.["Product Name"]
                        ? language?.["Product Name"]
                        : "Product Name"}
                    </p>
                  </div>
                  <div
                    className="text-xs font-medium font-inter flex items-center"
                    style={{
                      color: "#6A7878",
                      padding: "0px 12px",
                      width: `${calculatedWidth * 110}px`,
                    }}
                  >
                    <p>
                      {language && language?.["Quantity"]
                        ? language?.["Quantity"]
                        : "Quantity"}
                    </p>
                  </div>
                  <div
                    className="text-xs font-medium font-inter flex items-center"
                    style={{
                      color: "#6A7878",
                      padding: "0px 12px",
                      width: `${calculatedWidth * 110}px`,
                    }}
                  >
                    <p>
                      {language && language?.["Price"]
                        ? language?.["Price"]
                        : "Price"}
                    </p>
                  </div>
                  <div
                    className="text-xs font-medium font-inter flex items-center"
                    style={{
                      color: "#6A7878",
                      padding: "0px 12px",
                      width: `${calculatedWidth * 110}px`,
                    }}
                  >
                    <p>
                      {language && language?.["Tax"]
                        ? language?.["Tax"]
                        : "Tax"}
                    </p>
                  </div>
                  <div
                    className="text-xs font-medium font-inter flex items-center"
                    style={{
                      color: "#6A7878",
                      padding: "0px 12px",
                      width: `${calculatedWidth * 110}px`,
                    }}
                  >
                    <p>
                      {language && language?.["Discount"]
                        ? language?.["Discount"]
                        : "Discount"}
                    </p>
                  </div>
                  <div
                    className="text-xs font-medium font-inter flex items-center"
                    style={{
                      color: "#6A7878",
                      padding: "0px 12px",
                      width: `${calculatedWidth * 110}px`,
                    }}
                  >
                    <p>
                      {language && language?.["Total"]
                        ? language?.["Total"]
                        : "Total"}
                    </p>
                  </div>
                  <div
                    className="text-xs font-medium font-inter flex items-center"
                    style={{
                      color: "#6A7878",
                      padding: "0px 12px",
                      width: `${calculatedWidth * 40}px`,
                    }}
                  ></div>
                </div>
              )}
              {rows.map((row, index) => {
                if (row.recordType === 1) {
                  return (
                    <>
                      {isMobile ? (
                        <div
                          key={index}
                          style={{
                            border: "1px solid #DBE4E4",
                            padding: "16px",
                            borderRadius: "12px",
                            marginBottom: index === row.length - 1 ? "" : "12px",
                          }}
                        >
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter flex items-center justify-between"
                            style={{
                              color: "#4A5353",
                              width: `100%`,
                            }}
                          >
                            <div>
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["No"]
                                  ? language?.["No"]
                                  : "No"}
                              </p>
                              <p>{index + 1}</p>
                            </div>

                            {id === "new" ||
                              formValues?.status?.statusName === "Draft" ? (
                              <div
                                className="text-xs font-inter flex items-center cursor-pointer"
                                style={{
                                  color: "#6A7878",
                                  padding: "0px 12px",
                                  width: `40px`,
                                }}
                                onClick={() => handleDelete(index)}
                              >
                                <DeleteIcon />
                              </div>
                            ) : (
                              <div
                                className="text-xs font-medium font-inter flex items-center"
                                style={{
                                  color: "#6A7878",
                                  padding: "0px 12px",
                                  width: `40px`,
                                }}
                              ></div>
                            )}
                          </div>
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `100%`,
                              margin: "12px 0",
                            }}
                          >
                            <p style={{ color: "#6A7878", marginBottom: "4px" }}>
                              {language && language?.["Product Name"]
                                ? language?.["Product Name"]
                                : "Product Name"}
                            </p>
                            {id === "new" ||
                              formValues?.status?.statusName === "Draft" ? (
                              <div
                                className="relative"
                                style={{ width: "100%", height: "100%" }}
                                ref={dropdownProductPriceRef}
                              >
                                <DropdownSearch<{ itemName: string }>
                                  refKey={`product-${index}`}
                                  placeholder={language && language?.["Enter Product Name"]
                                    ? language?.["Enter Product Name"]
                                    : "Enter Product Name"}
                                  refs={{
                                    [`product-${index}`]: dropdownProductPriceRef,
                                  }}
                                  openStates={{
                                    [`product-${index}`]:
                                      isProductPriceDropdownOpen[index],
                                  }}
                                  open={() => {
                                    setIsProductPriceDropdownOpen((prev) => ({
                                      ...prev,
                                      [index]: true,
                                    }));
                                    asyncProduct.loadInitial();
                                  }}
                                  close={() =>
                                    setIsProductPriceDropdownOpen((prev) => ({
                                      ...prev,
                                      [index]: false,
                                    }))
                                  }
                                  data={asyncProduct.items}
                                  labelExtractor={(item) => item.itemName}
                                  value={
                                    isProductPriceDropdownOpen[index]
                                      ? asyncProduct.searchTerm
                                      : (rows[index]?.itemName ?? "")
                                  }
                                  setValue={asyncProduct.setSearchTerm}
                                  onSelect={(product) =>
                                    handleProductSelect(product, index)
                                  }
                                  tabIndex={0}
                                  onLoadMore={asyncProduct.loadMore}
                                  hasMore={asyncProduct.hasMore}
                                  loading={asyncProduct.isLoading}
                                  borderNone={false}
                                  serverSideSearch
                                  autoFocus={autoFocusIndex === index}
                                />
                              </div>
                            ) : (
                              // ...existing code...
                              <div className="py-2 cursor-pointer text-main">
                                {row?.itemName}
                              </div>
                            )}
                          </div>

                          <div className="flex items-center">
                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["Quantity"]
                                  ? language?.["Quantity"]
                                  : "Quantity"}
                              </p>
                              <div
                                className="flex items-center"
                                style={{ gap: "6px" }}
                              >
                                {(id === "new" ||
                                  formValues?.status?.statusName === "Draft") && (
                                    <div
                                      className="flex items-center justify-center cursor-pointer"
                                      style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "100%",
                                        backgroundColor: "#EBF0F0",
                                      }}
                                      onClick={() =>
                                        handleQuantityChange(index, "decrement")
                                      }
                                    >
                                      <MinusQuantity />
                                    </div>
                                  )}
                                <input
                                  disabled={
                                    id !== "new" &&
                                    formValues?.status?.statusName !== "Draft"
                                  }
                                  className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center text-center outline-none focus:none bg-transparent"
                                  style={{ width: "29px", height: "22px" }}
                                  value={row.quantity}
                                  onChange={(e) => handleInputChange(e, index)}
                                  onKeyDown={validateOnlyNumbers}
                                />
                                {(id === "new" ||
                                  formValues?.status?.statusName === "Draft") && (
                                    <div
                                      className="flex items-center justify-center cursor-pointer"
                                      style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "100%",
                                        backgroundColor: "#EBF0F0",
                                      }}
                                      onClick={() =>
                                        handleQuantityChange(index, "increment")
                                      }
                                    >
                                      <PlusQuantity />
                                    </div>
                                  )}
                              </div>
                            </div>
                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["Price"]
                                  ? language?.["Price"]
                                  : "Price"}
                              </p>
                              <p>
                                {Number(row.price)
                                  ? Number(row.price).toFixed(2)
                                  : 0}
                              </p>
                            </div>
                          </div>
                          <div
                            className="flex items-center"
                            style={{ margin: "12px 0px" }}
                          >
                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["TAX"]
                                  ? language?.["TAX"]
                                  : "TAX"}
                              </p>
                              <p>
                                {" "}
                                {getPrimaryTax(listTax, row.taxId ?? row.taxGroupId) !==
                                ""
                                  ? getPrimaryTax(
                                      listTax,
                                      row.taxId ?? row.taxGroupId,
                                    )
                                  : Number(row.tax)
                                    ? Number(row.tax).toFixed(2)
                                    : 0}
                              </p>
                            </div>
                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["Discount"]
                                  ? language?.["Discount"]
                                  : "Discount"}
                              </p>
                              <input
                                disabled={
                                  id !== "new" &&
                                  formValues?.status?.statusName !== "Draft"
                                }
                                tabIndex={0}
                                className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                                style={{ width: "100%", height: "22px" }}
                                value={row.discount}
                                placeholder={language && language?.["Enter Discount"]
                                  ? language?.["Enter Discount"]
                                  : "Enter Discount"}
                                onChange={(e) =>
                                  handleInputServiceChange(e, index, "discount")
                                }
                                onBlur={(e) =>
                                  handleBlurServiceChange(e, index, "discount")
                                }
                                onKeyDown={validateDecimalNumer}
                              />
                            </div>
                          </div>
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `100%`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["Amount"]
                                ? language?.["Amount"]
                                : "Amount"}
                            </p>
                            <p>
                              €{" "}
                              {Number(row?.amount)
                                ? Number(row?.amount).toFixed(2)
                                : 0}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div
                          key={index}
                          className="h-10 flex items-center"
                          style={{ borderBottom: "1px solid #E7F1F1" }}
                        >
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 40}px`,
                            }}
                          >
                            <p>{index + 1}</p>
                          </div>
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 132}px`,
                            }}
                          >
                            <p>{row?.sku ? row?.sku : ""}</p>
                          </div>
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              flexGrow: 1,
                              height: "100%",
                            }}
                          >
                            {id === "new" ||
                              formValues?.status?.statusName === "Draft" ? (
                              <div
                                className="relative"
                                style={{ width: "100%", height: "100%" }}
                                ref={dropdownProductPriceRef}
                              >
                                <DropdownSearch<{ itemName: string }>
                                  refKey={`product-${index}`}
                                  placeholder={language && language?.["Enter Product Name"]
                                    ? language?.["Enter Product Name"]
                                    : "Enter Product Name"}
                                  refs={{
                                    [`product-${index}`]: dropdownProductPriceRef,
                                  }}
                                  openStates={{
                                    [`product-${index}`]:
                                      isProductPriceDropdownOpen[index],
                                  }}
                                  open={() => {
                                    setIsProductPriceDropdownOpen((prev) => ({
                                      ...prev,
                                      [index]: true,
                                    }));
                                    asyncProduct.loadInitial();
                                  }}
                                  close={() =>
                                    setIsProductPriceDropdownOpen((prev) => ({
                                      ...prev,
                                      [index]: false,
                                    }))
                                  }
                                  data={asyncProduct.items}
                                  labelExtractor={(item) => item.itemName}
                                  value={
                                    isProductPriceDropdownOpen[index]
                                      ? asyncProduct.searchTerm
                                      : (rows[index]?.itemName ?? "")
                                  }
                                  setValue={asyncProduct.setSearchTerm}
                                  onSelect={(product) =>
                                    handleProductSelect(product, index)
                                  }
                                  tabIndex={0}
                                  onLoadMore={asyncProduct.loadMore}
                                  hasMore={asyncProduct.hasMore}
                                  loading={asyncProduct.isLoading}
                                  borderNone={true}
                                  serverSideSearch
                                  autoFocus={autoFocusIndex === index}
                                />
                              </div>
                            ) : (
                              // ...existing code...
                              <div className="py-2 cursor-pointer text-main">
                                {row?.itemName}
                              </div>
                            )}
                          </div>

                          <div
                            className="text-xs font-inter flex items-center space-x-1"
                            style={{
                              color: "#6A7878",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            {(id === "new" ||
                              formValues?.status?.statusName === "Draft") && (
                                <div
                                  className="flex items-center justify-center cursor-pointer"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "100%",
                                    backgroundColor: "#EBF0F0",
                                  }}
                                  onClick={() =>
                                    handleQuantityChange(index, "decrement")
                                  }
                                >
                                  <MinusQuantity />
                                </div>
                              )}
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center text-center outline-none focus:none bg-transparent"
                              style={{ width: "29px", height: "22px" }}
                              value={row.quantity}
                              onChange={(e) => handleInputChange(e, index)}
                              onKeyDown={validateOnlyNumbers}
                            />
                            {(id === "new" ||
                              formValues?.status?.statusName === "Draft") && (
                                <div
                                  className="flex items-center justify-center cursor-pointer"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "100%",
                                    backgroundColor: "#EBF0F0",
                                  }}
                                  onClick={() =>
                                    handleQuantityChange(index, "increment")
                                  }
                                >
                                  <PlusQuantity />
                                </div>
                              )}
                          </div>
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            <p>
                              {Number(row.price)
                                ? Number(row.price).toFixed(2)
                                : 0}
                            </p>
                          </div>
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            <p>
                              {" "}
                              {getPrimaryTax(listTax, row.taxId ?? row.taxGroupId) !==
                              ""
                                ? getPrimaryTax(
                                    listTax,
                                    row.taxId ?? row.taxGroupId,
                                  )
                                : Number(row.tax)
                                  ? Number(row.tax).toFixed(2)
                                  : 0}
                            </p>
                          </div>
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={0}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              value={row.discount}
                              placeholder={language && language?.["Enter Discount"]
                                ? language?.["Enter Discount"]
                                : "Enter Discount"}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "discount")
                              }
                              onBlur={(e) =>
                                handleBlurServiceChange(e, index, "discount")
                              }
                              onKeyDown={validateDecimalNumer}
                            />
                          </div>
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            <p>
                              €{" "}
                              {Number(row?.amount)
                                ? Number(row?.amount).toFixed(2)
                                : 0}
                            </p>
                          </div>
                          {id === "new" ||
                            formValues?.status?.statusName === "Draft" ? (
                            <div
                              className="text-xs font-inter flex items-center cursor-pointer"
                              style={{
                                color: "#6A7878",
                                padding: "0px 12px",
                                width: `${calculatedWidth * 40}px`,
                              }}
                              onClick={() => handleDelete(index)}
                            >
                              <DeleteIcon />
                            </div>
                          ) : (
                            <div
                              className="text-xs font-medium font-inter flex items-center"
                              style={{
                                color: "#6A7878",
                                padding: "0px 12px",
                                width: `${calculatedWidth * 40}px`,
                              }}
                            ></div>
                          )}
                        </div>
                      )}
                    </>
                  );
                } else {
                  return (
                    <>
                      {isMobile ? (
                        <div
                          key={index}
                          style={{
                            border: "1px solid #DBE4E4",
                            padding: "16px",
                            borderRadius: "12px",
                            marginBottom: index === row.length - 1 ? "" : "12px",
                          }}
                        >
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter flex items-center justify-between"
                            style={{
                              color: "#4A5353",
                              width: `100%`,
                            }}
                          >
                            <div>
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["No"]
                                  ? language?.["No"]
                                  : "No"}
                              </p>
                              <p>{index + 1}</p>
                            </div>

                            {id === "new" ||
                              formValues?.status?.statusName === "Draft" ? (
                              <div
                                className="text-xs font-inter flex items-center cursor-pointer"
                                style={{
                                  color: "#6A7878",
                                  padding: "0px 12px",
                                  width: `40px`,
                                }}
                                onClick={() => handleDelete(index)}
                              >
                                <DeleteIcon />
                              </div>
                            ) : (
                              <div
                                className="text-xs font-medium font-inter flex items-center"
                                style={{
                                  color: "#6A7878",
                                  padding: "0px 12px",
                                  width: `40px`,
                                }}
                              ></div>
                            )}
                          </div>
                          <div
                            className="flex items-center"
                            style={{
                              margin: "12px 0",
                            }}
                          >
                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["SKU"]
                                  ? language?.["SKU"]
                                  : "SKU"}
                              </p>
                              <input
                                disabled={
                                  id !== "new" &&
                                  formValues?.status?.statusName !== "Draft"
                                }
                                tabIndex={0}
                                className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                                style={{ width: "100%", height: "22px" }}
                                autoFocus={autoFocusIndex === index}
                                value={row.sku}
                                placeholder={language && language?.["Enter SKU"]
                                  ? language?.["Enter SKU"]
                                  : "Enter SKU"}
                                onKeyDown={validateNoSpecialCharsOrSpaces}
                                onChange={(e) =>
                                  handleInputServiceChange(e, index, "sku")
                                }
                              />
                            </div>

                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["Product Name"]
                                  ? language?.["Product Name"]
                                  : "Product Name"}
                              </p>
                              <input
                                disabled={
                                  id !== "new" &&
                                  formValues?.status?.statusName !== "Draft"
                                }
                                tabIndex={0}
                                className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                                style={{ width: "100%", height: "22px" }}
                                value={row.itemName}
                                placeholder={language && language?.["Enter Product Name"]
                                  ? language?.["Enter Product Name"]
                                  : "Enter Product Name"}
                                onKeyDown={validateNoSpecialChars}
                                onChange={(e) =>
                                  handleInputServiceChange(e, index, "itemName")
                                }
                              />
                            </div>
                          </div>
                          <div className="flex items-center">
                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["Quantity"]
                                  ? language?.["Quantity"]
                                  : "Quantity"}
                              </p>
                              <div
                                className="flex items-center"
                                style={{ gap: "6px" }}
                              >
                                {(id === "new" ||
                                  formValues?.status?.statusName === "Draft") && (
                                    <div
                                      className="flex items-center justify-center cursor-pointer"
                                      style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "100%",
                                        backgroundColor: "#EBF0F0",
                                      }}
                                      onClick={() =>
                                        handleQuantityChange(index, "decrement")
                                      }
                                    >
                                      <MinusQuantity />
                                    </div>
                                  )}
                                <input
                                  disabled={
                                    id !== "new" &&
                                    formValues?.status?.statusName !== "Draft"
                                  }
                                  className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center text-center outline-none focus:none bg-transparent"
                                  style={{ width: "29px", height: "22px" }}
                                  value={row.quantity}
                                  onChange={(e) => handleInputChange(e, index)}
                                  onKeyDown={validateOnlyNumbers}
                                />
                                {(id === "new" ||
                                  formValues?.status?.statusName === "Draft") && (
                                    <div
                                      className="flex items-center justify-center cursor-pointer"
                                      style={{
                                        width: "32px",
                                        height: "32px",
                                        borderRadius: "100%",
                                        backgroundColor: "#EBF0F0",
                                      }}
                                      onClick={() =>
                                        handleQuantityChange(index, "increment")
                                      }
                                    >
                                      <PlusQuantity />
                                    </div>
                                  )}
                              </div>
                            </div>
                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["Price"]
                                  ? language?.["Price"]
                                  : "Price"}
                              </p>
                              <input
                                disabled={
                                  id !== "new" &&
                                  formValues?.status?.statusName !== "Draft"
                                }
                                tabIndex={0}
                                className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                                style={{ width: "100%", height: "22px" }}
                                value={row.price}
                                placeholder={language && language?.["Enter Price"]
                                  ? language?.["Enter Price"]
                                  : "Enter Price"}
                                onChange={(e) =>
                                  handleInputServiceChange(e, index, "price")
                                }
                                onBlur={(e) =>
                                  handleBlurServiceChange(e, index, "price")
                                }
                                onKeyDown={validateDecimalNumer}
                              />
                            </div>
                          </div>
                          <div className="flex items-center">
                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["TAX"]
                                  ? language?.["TAX"]
                                  : "TAX"}
                              </p>
                              {id === "new" ||
                                formValues?.status?.statusName === "Draft" ? (
                                <div className="relative">
                                  <input
                                    type="text"
                                    placeholder="Selecct TAX"
                                    disabled={
                                      id !== "new" &&
                                      formValues?.status?.statusName !== "Draft"
                                    }
                                    onKeyDown={validateNoSpecialChars}
                                    tabIndex={0}
                                    value={
                                      searchTaxMap[index] !== undefined
                                        ? searchTaxMap[index]
                                        : ""
                                    }
                                    onChange={(e) => {
                                      const newValue = e.target.value;
                                      setSearchTaxMap((prev: any) => ({
                                        ...prev,
                                        [index]: newValue,
                                      }));

                                      setOpenDropdownIndexes((prev) => ({
                                        ...prev,
                                        [index]: true,
                                      }));
                                    }}
                                    onClick={() => handleTaxDropdownToggle(index)}
                                    className={`text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center outline-none focus:none bg-transparent`}
                                  />

                                  {openDropdownIndexes[index] && (
                                    <div
                                      className="absolute z-10 mt-1 bg-white rounded-lg max-h-60 overflow-auto p-1 shadow-extend"
                                      style={{ width: "200px" }}
                                    >
                                      {listTax.filter((tax: any) =>
                                        (tax?.primaryRate?.toString() ?? "")
                                          .toLowerCase()
                                          .includes((searchTaxMap[index] ?? "").toLowerCase())
                                      ).length === 0 ? (
                                        <div style={{ padding: "12px 0px" }}>
                                          <p className="text-[14px] font-inter leading-[20px] text-black text-center">
                                            {language &&
                                              language?.["No tax available"]
                                              ? language?.["No tax available"]
                                              : "No tax available"}
                                          </p>
                                          <p
                                            onClick={() => {
                                              webRoute("Configurations/tax");
                                            }}
                                            style={{
                                              marginTop: "12px",
                                              color: "#078D91",
                                            }}
                                            className="text-[14px] font-inter leading-[20px] text-center cursor-pointer"
                                          >
                                            {language &&
                                              language?.["Add as new tax?"]
                                              ? language?.["Add as new tax?"]
                                              : "Add as new tax?"}
                                          </p>
                                        </div>
                                      ) : (
                                        listTax.map((tax: any) => (
                                          <div
                                            key={tax.id}
                                            className="px-4 py-2 cursor-pointer text-main"
                                            onClick={() =>
                                              handleTaxSelect(tax, index)
                                            }
                                          >
                                            {tax.primaryRate}
                                          </div>
                                        ))
                                      )}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="py-2 cursor-pointer text-main">
                                  {
                                    listTax?.find((v: any) => v.id === row.taxGroupId)
                                      ?.primaryRate
                                  }
                                </div>
                              )}
                            </div>

                            <div
                              className="text-[14px] font-medium leading-[18px] font-inter"
                              style={{
                                color: "#4A5353",
                                width: `calc(50% - 12px)`,
                              }}
                            >
                              <p
                                style={{
                                  color: "#6A7878",
                                  marginBottom: "4px",
                                }}
                              >
                                {language && language?.["Discount"]
                                  ? language?.["Discount"]
                                  : "Discount"}
                              </p>
                              <input
                                disabled={
                                  id !== "new" &&
                                  formValues?.status?.statusName !== "Draft"
                                }
                                tabIndex={0}
                                className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                                style={{ width: "100%", height: "22px" }}
                                value={row.discount}
                                placeholder={language && language?.["Enter Discount"]
                                  ? language?.["Enter Discount"]
                                  : "Product Name"}
                                onChange={(e) =>
                                  handleInputServiceChange(e, index, "discount")
                                }
                                onBlur={(e) =>
                                  handleBlurServiceChange(e, index, "discount")
                                }
                                onKeyDown={validateDecimalNumer}
                              />
                            </div>
                          </div>
                          <div
                            className="text-[14px] font-medium leading-[18px] font-inter"
                            style={{
                              color: "#4A5353",
                              width: `100%`,
                            }}
                          >
                            <p
                              style={{
                                color: "#6A7878",
                                marginBottom: "4px",
                              }}
                            >
                              {language && language?.["Amount"]
                                ? language?.["Amount"]
                                : "Amount"}
                            </p>
                            <p>
                              €{" "}
                              {Number(row?.amount)
                                ? Number(row?.amount).toFixed(2)
                                : 0}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div
                          key={index}
                          className="h-10 flex items-center"
                          style={{ borderBottom: "1px solid #E7F1F1" }}
                        >
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 40}px`,
                            }}
                          >
                            <p>{index + 1}</p>
                          </div>
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 132}px`,
                            }}
                          >
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={0}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              autoFocus={autoFocusIndex === index}
                              value={row.sku}
                              placeholder={language && language?.["Enter SKU"]
                                ? language?.["Enter SKU"]
                                : "Enter SKU"}
                              onKeyDown={validateNoSpecialCharsOrSpaces}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "sku")
                              }
                            />
                          </div>

                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              flexGrow: 1,
                            }}
                          >
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={0}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              value={row.itemName}
                              onKeyDown={validateNoSpecialChars}
                              placeholder={language && language?.["Enter Product Name"]
                                ? language?.["Enter Product Name"]
                                : "Enter Product Name"}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "itemName")
                              }
                            />
                          </div>
                          <div
                            className="text-xs font-inter flex items-center space-x-1"
                            style={{
                              color: "#6A7878",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            {(id === "new" ||
                              formValues?.status?.statusName === "Draft") && (
                                <div
                                  className="flex items-center justify-center cursor-pointer"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "100%",
                                    backgroundColor: "#E7F1F1",
                                  }}
                                  onClick={() =>
                                    handleQuantityChange(index, "decrement")
                                  }
                                >
                                  <MinusQuantity />
                                </div>
                              )}
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={0}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center text-center outline-none focus:none bg-transparent"
                              style={{ width: "29px", height: "22px" }}
                              value={row.quantity}
                              onChange={(e) => handleInputChange(e, index)}
                              onKeyDown={validateOnlyNumbers}
                            />
                            {(id === "new" ||
                              formValues?.status?.statusName === "Draft") && (
                                <div
                                  className="flex items-center justify-center cursor-pointer"
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "100%",
                                    backgroundColor: "#E7F1F1",
                                  }}
                                  onClick={() =>
                                    handleQuantityChange(index, "increment")
                                  }
                                >
                                  <PlusQuantity />
                                </div>
                              )}
                          </div>
                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={0}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              value={row.price}
                              placeholder={language && language?.["Enter Price"]
                                ? language?.["Enter Price"]
                                : "Enter Price"}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "price")
                              }
                              onBlur={(e) =>
                                handleBlurServiceChange(e, index, "price")
                              }
                              onKeyDown={validateDecimalNumer}
                            />
                          </div>

                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            {id === "new" ||
                              formValues?.status?.statusName === "Draft" ? (
                              <div className="relative">
                                <input
                                  type="text"
                                  disabled={
                                    id !== "new" &&
                                    formValues?.status?.statusName !== "Draft"
                                  }
                                  onKeyDown={validateNoSpecialChars}
                                  tabIndex={0}
                                  value={
                                    searchTaxMap[index] !== undefined
                                      ? searchTaxMap[index]
                                      : ""
                                  }
                                  placeholder={language && language?.["Select TAX"]
                                    ? language?.["Select TAX"]
                                    : "Select TAX"}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    setSearchTaxMap((prev: any) => ({
                                      ...prev,
                                      [index]: newValue,
                                    }));

                                    setOpenDropdownIndexes((prev) => ({
                                      ...prev,
                                      [index]: true,
                                    }));
                                  }}
                                  onClick={() => handleTaxDropdownToggle(index)}
                                  className={`text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center outline-none focus:none bg-transparent`}
                                />

                                {openDropdownIndexes[index] && (
                                  <div
                                    className="absolute z-10 mt-1 bg-white rounded-lg max-h-60 overflow-auto p-1 shadow-extend"
                                    style={{ width: "200px" }}
                                  >
                                    {listTax.filter((tax: any) =>
                                      (tax?.primaryRate?.toString() ?? "")
                                        .toLowerCase()
                                        .includes((searchTaxMap[index] ?? "").toLowerCase())
                                    ).length === 0 ? (
                                      <div style={{ padding: "12px 0px" }}>
                                        <p className="text-[14px] font-inter leading-[20px] text-black text-center">
                                          {language &&
                                            language?.["No tax available"]
                                            ? language?.["No tax available"]
                                            : "No tax available"}
                                        </p>
                                        <p
                                          onClick={() => {
                                            webRoute("Configurations/tax");
                                          }}
                                          style={{
                                            marginTop: "12px",
                                            color: "#078D91",
                                          }}
                                          className="text-[14px] font-inter leading-[20px] text-center cursor-pointer"
                                        >
                                          {language &&
                                            language?.["Add as new tax?"]
                                            ? language?.["Add as new tax?"]
                                            : "Add as new tax?"}
                                        </p>
                                      </div>
                                    ) : (
                                      listTax.map((tax: any) => (
                                        <div
                                          key={tax.id}
                                          className="px-4 py-2 cursor-pointer text-main"
                                          onClick={() =>
                                            handleTaxSelect(tax, index)
                                          }
                                        >
                                          {tax.primaryRate}
                                        </div>
                                      ))
                                    )}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="py-2 cursor-pointer text-main">
                                {
                                  listTax?.find((v: any) => v.id === row.taxGroupId)
                                    ?.primaryRate
                                }
                              </div>
                            )}
                          </div>

                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            <input
                              disabled={
                                id !== "new" &&
                                formValues?.status?.statusName !== "Draft"
                              }
                              tabIndex={0}
                              className="text-[14px] font-inter placeholder:text-main text-main flex items-center justify-center  outline-none focus:none bg-transparent"
                              style={{ width: "100%", height: "22px" }}
                              value={row.discount}
                              placeholder={language && language?.["Enter Discount"]
                                ? language?.["Enter Discount"]
                                : "Enter Discount"}
                              onChange={(e) =>
                                handleInputServiceChange(e, index, "discount")
                              }
                              onBlur={(e) =>
                                handleBlurServiceChange(e, index, "discount")
                              }
                              onKeyDown={validateDecimalNumer}
                            />
                          </div>

                          <div
                            className="text-xs font-medium font-inter flex items-center"
                            style={{
                              color: "#6A7878",
                              fontSize: "14px",
                              padding: "0px 12px",
                              width: `${calculatedWidth * 110}px`,
                            }}
                          >
                            <p>
                              €{" "}
                              {Number(row?.amount)
                                ? Number(row?.amount).toFixed(2)
                                : 0}
                            </p>
                          </div>

                          {id === "new" ||
                            formValues?.status?.statusName === "Draft" ? (
                            <div
                              className="text-xs font-inter flex items-center cursor-pointer"
                              style={{
                                color: "#6A7878",
                                padding: "0px 12px",
                                width: `${calculatedWidth * 40}px`,
                              }}
                              onClick={() => handleDelete(index)}
                            >
                              <DeleteIcon />
                            </div>
                          ) : (
                            <div
                              className="text-xs font-medium font-inter flex items-center"
                              style={{
                                color: "#6A7878",
                                padding: "0px 12px",
                                width: `${calculatedWidth * 40}px`,
                              }}
                            ></div>
                          )}
                        </div>
                      )}
                    </>
                  );
                }
              })}
              {(id === "new" || formValues?.status?.statusName === "Draft") && (
                <div
                  className="flex items-center"
                  style={{
                    gap: "12px",
                    flexWrap: "wrap",
                    marginTop: "12px",
                    padding: isMobile ? "0px" : "0px 12px 4px",
                  }}
                >
                  {/* Two explicit, keyboard-native add buttons replace the old
                      click-only popup, so a line can be added with Enter and the
                      cursor lands straight in its first field. */}
                  <button
                    type="button"
                    onClick={() => handleSelectType("product")}
                    className="flex items-center justify-center cursor-pointer font-inter"
                    style={{
                      gap: "8px",
                      padding: "8px 16px",
                      width: isMobile ? "100%" : "fit-content",
                      border: "1px solid #0F7679",
                      borderRadius: "30px",
                      background: "transparent",
                    }}
                  >
                    <span
                      className="flex items-center justify-center"
                      style={{ width: "20px", height: "20px" }}
                    >
                      <PlusGreenIcon />
                    </span>
                    <span
                      className="text-[14px] leading-[20px] font-medium"
                      style={{ color: "#0F7679" }}
                    >
                      {language && language?.["Add product"]
                        ? language?.["Add product"]
                        : "Add product"}
                    </span>
                  </button>
                  <button
                    type="button"
                    onClick={() => handleSelectType("service")}
                    className="flex items-center justify-center cursor-pointer font-inter"
                    style={{
                      gap: "8px",
                      padding: "8px 16px",
                      width: isMobile ? "100%" : "fit-content",
                      border: "1px solid #DBE4E4",
                      borderRadius: "30px",
                      background: "transparent",
                    }}
                  >
                    <span
                      className="flex items-center justify-center"
                      style={{ width: "20px", height: "20px" }}
                    >
                      <PlusGreenIcon />
                    </span>
                    <span
                      className="text-[14px] leading-[20px] font-medium"
                      style={{ color: "#4A5353" }}
                    >
                      {language && language?.["Add custom line"]
                        ? language?.["Add custom line"]
                        : "Add custom line"}
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="" style={{ marginTop: "24px" }}>
            <div className="" style={{ width: "100%" }}>
              <p
                className="text-[14px] font-inter leading-[20px]"
                style={{ color: "#4A5353", fontWeight: "500" }}
              >
                {language && language?.["Description"]
                  ? language?.["Description"]
                  : "Description"}
              </p>
              <textarea
                tabIndex={0}
                style={{ height: "134px", marginTop: "6px" }}
                // Notes are free text: allow normal punctuation (. , ' etc.) and
                // only block characters that could break rendering or storage.
                onKeyDown={(e) => {
                  if (["<", ">", "{", "}", "\\"].includes(e.key))
                    e.preventDefault();
                }}
                name="note"
                value={formValues?.note}
                onChange={(e: any) => {
                  handleChange(e);
                }}
                className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg  outline-none focus-none bg-white w-full`}
              />
            </div>
            <div
              className="flex items-start"
              style={{ gap: "24px", marginTop: "24px", flexWrap: "wrap" }}
            >
              <div
                className=""
                style={{
                  width: isMobile ? "100%" : "calc(50% - 12px)",
                  overflow: "hidden",
                  height: "fit-content",
                }}
              >
                {/* {formValuesPayment?.salePayment?.map((v: any) => {
                  return (
                    <div
                      className="flex items-center justify-between border-b border-[#EBEBED] text-[12px] text-main leading-[17px] font-inter"
                      style={{
                        backgroundColor: "white",
                        height: "40px",
                        padding: "0px 12px",
                      }}
                    >
                      <p style={{ fontSize: "12px" }}>
                        {language && language?.["Subtotal"]
                          ? language?.["Subtotal"]
                          : "Subtotal"}
                        <span className="text-body ml-1">
                          {formatDate(v?.createdAt)}
                        </span>
                      </p>
                      <p>{v?.amount ? Number(v?.amount).toFixed(2) : 0} € </p>
                    </div>
                  );
                })} */}

                <div
                  className="flex items-center justify-between"
                  style={{
                    padding: "24px",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    border: "1px solid #DBE4E4",
                  }}
                >
                  <div className="flex items-center gap-x-2">
                    <div
                      className="flex items-center justify-center"
                      style={{ width: "24px", height: "24px" }}
                    >
                      <BalanceIcon />
                    </div>
                    <p
                      style={{
                        fontSize: "16px",
                        color: "#222525",
                        fontWeight: "500",
                      }}
                      className=" font-inter"
                    >
                      {language && language?.["BALANCE"]
                        ? language?.["BALANCE"]
                        : "BALANCE"}
                    </p>
                  </div>
                  <p
                    className=" font-inter"
                    style={{ fontSize: "16px", color: "#6A7878" }}
                  >
                    €
                    {(
                      (Array.isArray(rows) && rows.length > 0
                        ? rows.reduce(
                          (acc: number, val: any) =>
                            acc + (Number(val.amount) || 0),
                          0,
                        )
                        : 0) -
                      (formValuesPayment?.salePayment &&
                      Array.isArray(formValuesPayment.salePayment)
                        ? formValuesPayment.salePayment.reduce(
                            (acc: number, val: any) =>
                              acc + (Number(val.amount) || 0),
                            0,
                          )
                        : 0)
                    ).toFixed(2) || "0.00"}{" "}
                  </p>
                </div>
                {formValuesPayment?.salePayment &&
                  Array.isArray(formValuesPayment.salePayment) &&
                  formValuesPayment.salePayment.length > 0 && (
                    <div
                      style={{
                        borderTop: "1px solid #EBEBED",
                        padding: "12px 24px",
                      }}
                    >
                      {formValuesPayment.salePayment.map((payment: any, index: number) => (
                        <div
                          key={payment?.id ?? index}
                          className="flex items-center justify-between font-inter"
                          style={{
                            fontSize: "14px",
                            color: "#4A5353",
                            padding: "6px 0",
                          }}
                        >
                          <span>
                            {(language?.["Payment"] ?? "Payment")} {index + 1}
                            {" – "}
                            {payment?.createdAt
                              ? formatDate(payment.createdAt)
                              : "–"}
                          </span>
                          <span style={{ fontWeight: "500" }}>
                            {payment?.amount != null
                              ? Number(payment.amount).toFixed(2)
                              : "0.00"}{" "}
                            €
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                <div
                  className="flex items-center justify-center gap-x-1 cursor-pointer"
                  style={{
                    backgroundColor: "#EBF0F0",
                    height: "40px",
                    padding: "8px 0px",
                    border: "1px solid transparent",
                    borderBottomLeftRadius: "16px",
                    borderBottomRightRadius: "16px",
                  }}
                  onClick={() => {
                    setShowPayment(true);
                  }}
                >
                  <PlusGreenIcon />
                  <p
                    className="text-[14px] leading-[22px] font-inter"
                    style={{ color: "#0F7679", fontWeight: "500" }}
                  >
                    {language && language?.["Add new payment"]
                      ? language?.["Add new payment"]
                      : "Add new payment"}
                  </p>
                </div>
              </div>
              <div
                style={{
                  width: isMobile ? "100%" : "calc(50% - 12px)",
                  overflow: "hidden",
                  height: "fit-content",
                }}
              >
                <div
                  style={{
                    padding: "24px",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    border: "1px solid #DBE4E4",
                  }}
                >
                  <div
                    className="flex items-center justify-between"
                    style={{
                      backgroundColor: "white",
                      height: "36px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#000000",
                        fontWeight: "500",
                      }}
                      className="font-inter"
                    >
                      {language && language?.["Subtotal"]
                        ? language?.["Subtotal"]
                        : "Subtotal"}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#4A5353",
                        fontWeight: "500",
                        fontVariantNumeric: "tabular-nums",
                      }}
                      className="text-main leading-[17px] font-inter"
                    >
                      {id === "new"
                        ? rows
                          .reduce(
                            (acc: any, val: any) =>
                              acc +
                              Number(val.amount) /
                              (1 + Number(val.tax) / 100),
                            0,
                          )
                          .toFixed(2)
                        : rows
                          .reduce(
                            (acc: any, val: any) => acc + Number(val.net),
                            0,
                          )
                          .toFixed(2)}{" "}
                      €
                    </p>
                  </div>
                  <div
                    className="flex items-center justify-between"
                    style={{
                      backgroundColor: "white",
                      height: "36px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "14px",
                        color: "black",
                        fontWeight: "500",
                      }}
                      className="text-main leading-[17px] font-inter"
                    >
                      {language && language?.["Tax"]
                        ? language?.["Tax"]
                        : "Tax"}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#4A5353",
                        fontWeight: "500",
                        fontVariantNumeric: "tabular-nums",
                      }}
                      className="text-main leading-[17px] font-inter"
                    >
                      {id === "new"
                        ? rows
                          .reduce(
                            (acc: any, val: any) =>
                              acc +
                              (Number(val.amount) -
                                Number(val.amount) /
                                (1 + Number(val.tax) / 100)),
                            0,
                          )
                          .toFixed(2)
                        : rows
                          .reduce(
                            (acc: any, val: any) => acc + Number(val.tax),
                            0,
                          )
                          .toFixed(2)}{" "}
                      €
                    </p>
                  </div>
                  <div
                    className="flex items-center justify-between"
                    style={{
                      backgroundColor: "white",
                      height: "36px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "14px",
                        color: "black",
                        fontWeight: "500",
                      }}
                      className="text-main leading-[17px] font-inter"
                    >
                      {language && language?.["Discount"]
                        ? language?.["Discount"]
                        : "Discount"}
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#4A5353",
                        fontWeight: "500",
                        fontVariantNumeric: "tabular-nums",
                      }}
                      className="text-main leading-[17px] font-inter"
                    >
                      {rows
                        .reduce(
                          (acc: any, val: any) => acc + Number(val.discount),
                          0,
                        )
                        .toFixed(2)}{" "}
                      €
                    </p>
                  </div>
                </div>
                <div
                  className="flex items-center justify-between border-b border-[#EBEBED] "
                  style={{
                    backgroundColor: "#EBF0F0",
                    padding: "16px",
                    border: "1px solid transparent",
                    borderBottomLeftRadius: "16px",
                    borderBottomRightRadius: "16px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#222525",
                    }}
                    className="text-main leading-[24px] font-inter"
                  >
                    {language && language?.["TOTAL"]
                      ? language?.["TOTAL"]
                      : "TOTAL"}
                  </p>
                  <p
                    style={{
                      fontSize: "20px",
                      color: "#222525",
                      fontWeight: "700",
                      fontVariantNumeric: "tabular-nums",
                    }}
                    className="text-main leading-[24px] font-inter"
                  >
                    {rows
                      .reduce(
                        (acc: any, val: any) => acc + Number(val.amount),
                        0,
                      )
                      .toFixed(2)}{" "}
                    €
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`fixed inset-0 flex items-end justify-end duration-300`}
            style={{
              height: "100vh",
              width: "100vw",
              backgroundColor: "#22252552",
              top: 0,
              left: 0,
              opacity: showPayment ? 1 : 0,
              zIndex: "200",
              pointerEvents: showPayment ? "auto" : "none",
            }}
            // Click the dimmed backdrop (outside the panel) to dismiss.
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowPayment(false);
            }}
          >
            <div
              style={{
                width: isMobile ? "90%" : "30%",
                height: "100%",
                padding: "24px",
                backgroundColor: "#FFFFFF",
                transform: showPayment ? "translateX(0)" : "translateX(100%)",
                transition: "transform 0.3s cubic-bezier(0.32, 0.72, 0, 1)",
              }}
              className="shadow_panel "
            >
              <div className="flex items-center justify-between">
                <p
                  className="font-inter font-semibold leading-[24px] text-main"
                  style={{ fontSize: "20px" }}
                >
                  {language && language?.["New payment"]
                    ? language?.["New payment"]
                    : "New payment"}
                </p>
                <button
                  type="button"
                  aria-label={
                    language && language?.["Close payment form"]
                      ? language?.["Close payment form"]
                      : "Close payment form"
                  }
                  onClick={() => {
                    setShowPayment(false);
                  }}
                  className="flex items-center justify-center cursor-pointer"
                  style={{ background: "transparent", border: "none", padding: 0 }}
                >
                  <CloseIcon />
                </button>
              </div>
              <div
                className="flex items-center justify-between"
                style={{
                  backgroundColor: "#EBF0F0",
                  padding: "24px",
                  height: "80px",
                  borderRadius: "16px",
                  marginTop: "24px",
                }}
              >
                <p
                  className="font-semibold font-inter leading-[32px]"
                  style={{ color: "#4A5353", fontSize: "24px" }}
                >
                  {language && language?.["Balance"]
                    ? language?.["Balance"]
                    : "Balance"}
                </p>
                <p
                  className="font-semibold font-inter leading-[32px]"
                  style={{ color: "#0F7679", fontSize: "24px" }}
                >
                  {(
                    (Array.isArray(rows) && rows.length > 0
                      ? rows.reduce(
                          (acc: number, val: any) =>
                            acc + (Number(val.amount) || 0),
                          0,
                        )
                      : 0) -
                    (formValuesPayment?.salePayment &&
                    Array.isArray(formValuesPayment.salePayment)
                      ? formValuesPayment.salePayment.reduce(
                          (acc: number, val: any) =>
                            acc + (Number(val.amount) || 0),
                          0,
                        )
                      : 0)
                  ).toFixed(2) || "0.00"}{" "}
                  €
                </p>
              </div>
              {formValues?.creditNote?.id && (
                <div className="" style={{ marginTop: "24px" }}>
                  <p
                    className="font-medium font-inter"
                    style={{ color: "#222525", fontSize: "14px" }}
                  >
                    {language && language?.["Credit notes"]
                      ? language?.["Credit notes"]
                      : "Credit notes"}
                  </p>
                  <div
                    className="flex items-center justify-between"
                    style={{
                      border: "1px solid #EBF0F0",
                      padding: "12px 16px",
                      borderRadius: "12px",
                      marginTop: "8px",
                    }}
                  >
                    <div>
                      <p
                        className="font-semibold font-inter"
                        style={{ color: "#222525", fontSize: "16px" }}
                      >
                        {language && language?.["CN-48392"]
                          ? language?.["CN-48392"]
                          : "CN-48392"}
                      </p>
                      <p
                        className="font-medium font-inter"
                        style={{ color: "#6A7878", fontSize: "14px" }}
                      >
                        {language && language?.["Amount: "]
                          ? language?.["Amount: "]
                          : "Amount: "}
                        <span style={{ color: "#4A5353" }}>
                          {" "}
                          € {formValues?.creditNote?.remainingAmount}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div style={{ marginTop: "24px" }}>
                <p
                  className="text-[14px] leading-[20px] font-inter font-medium"
                  style={{ color: "#222525" }}
                >
                  {language && language?.["Payment details"]
                    ? language?.["Payment details"]
                    : "Payment details"}
                </p>
                <div
                  className=""
                  style={{
                    marginTop: "8px",
                    borderRadius: "16px",
                    border: "1px solid #EBEBED",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="flex items-center justify-between"
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #EBF0F0",
                    }}
                  >
                    <p
                      className="font-medium font-inter leading-[17px]"
                      style={{ color: "#222525", fontSize: "14px" }}
                    >
                      {language && language?.["Select type"]
                        ? language?.["Select type"]
                        : "Select type"}
                    </p>
                    <div style={{ maxWidth: "200px" }}>
                      <DropdownSearch
                        refKey="type"
                        refs={{ type: paymentRef }}
                        openStates={{ type: isTypeDropdownOpen }}
                        open={(key) =>
                          key === "type" && setIsTypeDropdownOpen(true)
                        }
                        close={(key) =>
                          key === "type" && setIsTypeDropdownOpen(false)
                        }
                        data={listPayment}
                        labelExtractor={(item) => item.paymentName}
                        value={paymentType}
                        setValue={setPayemntType}
                        onSelect={handlePaymentTypeSelect}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between "
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #EBF0F0",
                    }}
                  >
                    <p
                      className="font-medium font-inter leading-[17px] "
                      style={{ color: "#222525", fontSize: "14px" }}
                    >
                      {language && language?.["Reference"]
                        ? language?.["Reference"]
                        : "Reference"}
                    </p>
                    <div className="flex items-center gap-x-2" style={{}}>
                      <input
                        className="text-[14px] font-inter placeholder:text-main text-main p-3 outline-none focus:none bg-transparent"
                        style={{
                          height: "100%",
                          textAlign: "left",
                          maxWidth: "200px",
                          border: "1px solid #DBE4E4",
                          borderRadius: "12px",
                        }}
                        value={formValuesPayment?.reference}
                        name="reference"
                        onChange={(e) => handlePaymentChange(e)}
                        onKeyDown={validateNoSpecialChars}
                      />
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between"
                    style={{
                      padding: "12px",
                      borderBottom: "1px solid #EBF0F0",
                    }}
                  >
                    <p
                      className="font-medium font-inter leading-[17px]"
                      style={{ color: "#222525", fontSize: "14px" }}
                    >
                      {language && language?.["Value"]
                        ? language?.["Value"]
                        : "Value"}
                    </p>
                    <div className="flex items-center gap-x-1 relative">
                      <input
                        className="text-[14px] font-inter placeholder:text-main text-main p-3 outline-none focus:none bg-transparent"
                        style={{
                          height: "100%",
                          textAlign: "left",
                          maxWidth: "200px",
                          border: "1px solid #DBE4E4",
                          borderRadius: "12px",
                        }}
                        value={formValuesPayment?.value}
                        name="value"
                        onChange={(e) => handlePaymentChange(e)}
                        onKeyDown={validateDecimalNumer}
                      />
                      <div
                        className="absolute"
                        style={{
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <p
                          className="font-medium font-inter leading-[17px]"
                          style={{ color: "#6A7878", fontSize: "16px" }}
                        >
                          €
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-center gap-x-1 cursor-pointer"
                    style={{ backgroundColor: "white", padding: "16px 8px" }}
                  >
                    <PlusIconGray />
                    <p
                      className="text-[14px] leading-[22px] font-inter"
                      style={{ color: "#C9D7D8" }}
                    >
                      {language && language?.["Add new payment"]
                        ? language?.["Add new payment"]
                        : "Add new payment"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="">
                {statusPayment && (
                  <div
                    className="p-3 flex items-center gap-x-2 duration-300"
                    style={{
                      marginTop: "24px",
                      backgroundColor: "#FFF5F5",
                      borderRadius: "4px",
                    }}
                  >
                    <ErrorIcon />
                    <p
                      style={{ fontSize: "12px" }}
                      className=" font-inter leading-[16px] font-semibold text-subtitle"
                    >
                      {language &&
                        language?.[
                        "The payment amount is greater than the total payment"
                        ]
                        ? language?.[
                        "The payment amount is greater than the total payment"
                        ]
                        : "The payment amount is greater than the total payment"}
                      .
                    </p>
                  </div>
                )}
                <div
                  className="absolute flex items-center px-6 gap-x-3"
                  style={{ bottom: "24px", right: "20px" }}
                >
                  <div
                    onClick={() => {
                      handleResetPayment();
                    }}
                    className="cursor-pointer text-[14px] leading-[22px] font-inter flex items-center justify-center"
                    style={{
                      borderRadius: "30px",
                      padding: "10px 24px",
                      border: "1px solid #C9D7D8",
                      color: "#222525",
                    }}
                  >
                    {language && language?.["Cancel"]
                      ? language?.["Cancel"]
                      : "Cancel"}
                  </div>
                  <div
                    onClick={() => {
                      handlePayment();
                    }}
                    className="cursor-pointer text-[14px] leading-[22px] font-inter flex items-center justify-center"
                    style={{
                      borderRadius: "30px",
                      padding: "10px 24px",
                      backgroundColor: "#0F7679",
                      color: "#FFFFFF",
                    }}
                  >
                    {language && language?.["Save"]
                      ? language?.["Save"]
                      : "Save"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

      </div>
      <div
        className="w-full flex items-center justify-end shadow_button relative"
        style={{ gap: "12px", paddingTop: "24px", }}
      >
        <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
        <div
          onClick={() => {
            webNavigate("/" + preLanguage + "/sales");
          }}
          style={{
            padding: "10px 24px",
            borderRadius: "30px",
            color: "#222525",
            fontSize: "14px",
            fontWeight: "500",
            border: "1px solid #C9D7D8",
          }}
          className="font-inter cursor-pointer"
        >
          {language && language?.["Cancel"] ? language?.["Cancel"] : "Cancel"}
        </div>
        {formValues?.status?.statusName !== "Rejected" &&
          formValues?.status?.statusName !== "Cancelled" && (
            <div className="flex items-center gap-x-3" style={{ opacity: submitting ? 0.6 : 1, pointerEvents: submitting ? "none" : "auto" }}>
              {id === "new" ? (
                <>
                  {/* Button Save as Draft */}
                  <div
                    onClick={(e: any) => {
                      submitGuarded(e, "draft");
                    }}
                    style={{
                      padding: "10px 24px",
                      borderRadius: "30px",
                      color: "#222525",
                      fontSize: "14px",
                      fontWeight: "500",
                      border: "1px solid #C9D7D8",
                    }}
                    className="cursor-pointer flex items-center justify-center"
                  >
                    <p className="text-[14px] leading-[20px] text-main font-inter">
                      {language && language?.["Save as draft"]
                        ? language?.["Save as draft"]
                        : "Save as draft"}
                    </p>
                  </div>

                  {/* Button Save */}
                  <div
                    style={{
                      padding: "10px 24px",
                      borderRadius: "30px",
                      color: "#FFFFFF",
                      fontSize: "14px",
                      fontWeight: "500",
                      backgroundColor: "#0F7679",
                    }}
                    onClick={(e: any) => {
                      submitGuarded(e, "save");
                    }}
                    className="cursor-pointer flex items-center justify-center"
                  >
                    <p className="text-[14px] font-medium leading-[22px] font-inter">
                      {language && language?.["Save"]
                        ? language?.["Save"]
                        : "Save"}
                    </p>
                  </div>
                </>
              ) : (
                id.length > 4 && (
                  <>
                    {/* Button Update */}
                    <div
                      onClick={(e: any) => {
                        submitGuarded(e, "save");
                      }}
                      className="cursor-pointer flex items-center justify-center gap-x-2 "
                      style={{
                        padding: "10px 24px",
                        borderRadius: "30px",
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: "500",
                        backgroundColor: "#0F7679",
                      }}
                    >
                      <p className="text-[14px] font-medium leading-[22px] font-inter">
                        {language && language?.["Update"]
                          ? language?.["Update"]
                          : "Update"}
                      </p>
                    </div>

                    {/* Button Reject */}
                    {(formValues?.status?.statusName === "Sent" ||
                      formValues?.status?.statusName === "Overdue") && (
                        <div
                          onClick={() => {
                            setShowOption({
                              check: true,
                              type: "Reject",
                            });
                          }}
                          style={{
                            padding: "10px 24px",
                            borderRadius: "30px",
                            color: "white",
                            backgroundColor: "#BA0E13",
                          }}
                          className="cursor-pointer flex items-center justify-center"
                        >
                          <p className="text-[14px] leading-[20px] font-inter font-medium">
                            {language && language?.["Reject"]
                              ? language?.["Reject"]
                              : "Reject"}
                          </p>
                        </div>
                      )}

                    {/* Button Cancel */}
                    {formValues?.status?.statusName !== "Paid" && (
                      <div
                        onClick={() => {
                          setShowOption({
                            check: true,
                            type: "Cancel",
                          });
                        }}
                        className="cursor-pointer flex items-center justify-center"
                        style={{
                          padding: "10px 24px",
                          borderRadius: "30px",
                          border: "1px solid #BA0E13",
                          color: "#BA0E13",
                        }}
                      >
                        <p className="text-[14px] leading-[20px] font-inter font-medium">
                          {language && language?.["Cancel sale"]
                            ? language?.["Cancel sale"]
                            : "Cancel sale"}
                        </p>
                      </div>
                    )}
                  </>
                )
              )}
            </div>
          )}
      </div>
      <PopupLocation
        show={showPopup}
        title={`${id === "new"
          ? language && language?.["Create Sales"]
            ? language?.["Create Sales"]
            : "Create Sales"
          : language && language?.["Update Sales"]
            ? language?.["Update Sales"]
            : "Update Sales"
          }`}
        desc={`${locationId === ""
          ? language &&
            language?.[
            "Please select location in the upper left corner to continue creating"
            ]
            ? language?.[
            "Please select location in the upper left corner to continue creating"
            ]
            : "Please select location in the upper left corner to continue creating"
          : id === "new"
            ? language && language?.["Create Sales Falied"]
              ? language?.["Create Sales Falied"]
              : "Create Sales Falied"
            : language && language?.["Update Sales Falied"]
              ? language?.["Update Sales Falied"]
              : "Update Sales Falied"
          }`}
        onClose={handleClosePopup}
        onOpen={handleOpenPopup}
      />
      <div
        className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showOption?.check
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
          } transition-opacity duration-300 ease-in-out`}
        style={{
          backgroundColor: "#22252552",
          zIndex: "200",
          transition: "opacity 0.3s ease, visibility 0.3s ease",
          width: "100%",
        }}
      >
        <div
          className={`transform transition-transform duration-300 ease-in-out ${showOption?.check ? "translate-y-0" : "translate-y-4 opacity-0"}`}
          style={{
            padding: "24px",
            borderRadius: "24px",
            backgroundColor: "#FFFFFF",
            width: "530px",
            transition: "transform 0.3s ease, opacity 0.3s ease",
          }}
        >
          <div className="flex items-center justify-between">
            <p
              style={{ fontSize: "20px" }}
              className="font-semibold font-inter text-main leading-[24px]"
            >
              {showOption?.type === "Cancel" ? "Cancel Sale" : "Reject Sale"}
            </p>
            <div
              onClick={() =>
                setShowOption({
                  check: false,
                  type: "",
                })
              }
              className="flex items-center justify-center cursor-pointer"
              style={{
                width: "24px",
                height: "24px",
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <div
            className="flex items-center justify-between"
            style={{ marginTop: "12px" }}
          >
            <p
              className="text-[14px] font-inter leading-[24px]"
              style={{ color: "#6A7878" }}
            >
              {(() => {
                const actionType =
                  showOption?.type === "Cancel" ? "cancel" : "reject";
                const message = `You will permanently ${actionType} the sale`;
                return language && language?.[message]
                  ? language?.[message]
                  : message;
              })()}
            </p>
          </div>
          <div
            className="flex items-center justify-end"
            style={{ marginTop: "24px", gap: "12px" }}
          >
            <div
              onClick={() =>
                setShowOption({
                  check: false,
                  type: "",
                })
              }
              className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
              style={{
                borderRadius: "30px",
                padding: "10px 24px",
                border: "1px solid #C9D7D8",
                color: "#222525",
              }}
            >
              {language && language?.["Cancel"]
                ? language?.["Cancel"]
                : "Cancel"}
            </div>
            <div
              onClick={handleDeleteSale}
              className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
              style={{
                borderRadius: "30px",
                padding: "10px 24px",
                backgroundColor: "#BA0E13",
                color: "#FFFFFF",
              }}
            >
              {showOption?.type === "Cancel" ? "Cancel Sale" : "Reject Sale"}
            </div>
          </div>
        </div>
      </div>
      <style>{`
        @media print {
          body * { visibility: hidden; }
          .sales-print-content, .sales-print-content * { visibility: visible; }
          .sales-print-content {
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
            width: 100% !important;
            background: white;
          }
          .no-print { display: none !important; }
        }
      `}</style>
      <div
        ref={printRef}
        className="sales-print-content"
        style={{ position: "absolute", left: "-9999px", top: 0, width: "210mm" }}
        aria-hidden="true"
      >
        <SalesPrintView
          invoiceNumber={formValues?.invoiceNumber}
          companyDetail={formValues?.companyDetail ?? null}
          clientDetail={formValues?.clientDetail ?? null}
          issuedOn={formValues?.issuedOn}
          paymentTerm={searchTerm ? language?.[searchTerm] ?? searchTerm : ""}
          locationName={formValues?.locationName ?? ""}
          rows={rows}
          companyBankDetails={formValues?.companyBankDetails ?? []}
          formatDate={formatDate}
        />
      </div>
    </>
  );
};
export default CreateSales;
